import { SVGProps } from "react";
import { ReactComponent as IssuerDashboardConnector } from "./Resources/IssuerDashboardConnector.svg";
import { twMerge } from "tailwind-merge";

export { IssuerDashboardConnector };
export const View = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_35_4325" fill="white">
        <path d="M10.3752 5.91668C9.56756 5.91668 8.77809 6.15616 8.10658 6.60484C7.43508 7.05352 6.91171 7.69125 6.60265 8.43739C6.2936 9.18352 6.21273 10.0045 6.37029 10.7966C6.52785 11.5887 6.91675 12.3163 7.48781 12.8874C8.05887 13.4584 8.78645 13.8473 9.57854 14.0049C10.3706 14.1624 11.1917 14.0816 11.9378 13.7725C12.6839 13.4635 13.3216 12.9401 13.7703 12.2686C14.219 11.5971 14.4585 10.8076 14.4585 10C14.4585 8.91704 14.0283 7.87843 13.2625 7.11266C12.4967 6.34688 11.4581 5.91668 10.3752 5.91668ZM10.3752 12.5833C9.86423 12.5833 9.36477 12.4318 8.93994 12.148C8.51511 11.8641 8.184 11.4607 7.98847 10.9886C7.79295 10.5166 7.74179 9.99714 7.84147 9.49603C7.94115 8.99491 8.18718 8.5346 8.54847 8.17332C8.90976 7.81203 9.37006 7.56599 9.87118 7.46631C10.3723 7.36664 10.8917 7.41779 11.3638 7.61332C11.8358 7.80885 12.2393 8.13996 12.5231 8.56479C12.807 8.98961 12.9585 9.48907 12.9585 10C12.9585 10.6852 12.6863 11.3422 12.2019 11.8267C11.7174 12.3112 11.0603 12.5833 10.3752 12.5833ZM19.2835 8.93334C18.957 8.26134 18.5299 7.64311 18.0168 7.10001C17.0506 6.07343 15.925 5.20954 14.6835 4.54168C13.3682 3.79175 11.8886 3.37679 10.3752 3.33334C8.07297 3.45388 5.87539 4.33291 4.12516 5.83334C3.35802 6.43729 2.67182 7.13749 2.0835 7.91668C1.84623 8.24412 1.63979 8.59283 1.46683 8.95834C1.30944 9.2839 1.22147 9.63863 1.2085 10C1.21798 10.3699 1.30604 10.7335 1.46683 11.0667C1.79331 11.7387 2.22045 12.3569 2.7335 12.9C3.69971 13.9266 4.8253 14.7905 6.06683 15.4583C7.38215 16.2083 8.8617 16.6232 10.3752 16.6667C12.6774 16.5461 14.8749 15.6671 16.6252 14.1667C17.4054 13.5732 18.1056 12.8814 18.7085 12.1083C18.9458 11.7809 19.1522 11.4322 19.3252 11.0667C19.4716 10.7303 19.5454 10.3668 19.5418 10C19.5323 9.63016 19.4443 9.26655 19.2835 8.93334ZM17.7585 10.3917C17.5032 10.8982 17.1747 11.3643 16.7835 11.775C15.9566 12.6599 14.9947 13.408 13.9335 13.9917C12.8481 14.6147 11.626 14.961 10.3752 15C8.45558 14.8841 6.62655 14.1437 5.16683 12.8917C4.51647 12.3787 3.93402 11.785 3.4335 11.125C3.26318 10.8952 3.11528 10.6497 2.99183 10.3917C2.9324 10.2681 2.89302 10.1359 2.87516 10C2.89302 9.86409 2.9324 9.73188 2.99183 9.60834C3.24713 9.10185 3.57566 8.63574 3.96683 8.22501C4.79372 7.34015 5.75565 6.59197 6.81683 6.00834C7.90222 5.38531 9.12428 5.03901 10.3752 5.00001C12.2947 5.11596 14.1238 5.85635 15.5835 7.10834C16.2339 7.62135 16.8163 8.215 17.3168 8.87501C17.4871 9.10478 17.635 9.35035 17.7585 9.60834C17.8179 9.73188 17.8573 9.86409 17.8752 10C17.8573 10.1359 17.8179 10.2681 17.7585 10.3917Z" />
      </mask>
      <path
        d="M10.3752 5.91668C9.56756 5.91668 8.77809 6.15616 8.10658 6.60484C7.43508 7.05352 6.91171 7.69125 6.60265 8.43739C6.2936 9.18352 6.21273 10.0045 6.37029 10.7966C6.52785 11.5887 6.91675 12.3163 7.48781 12.8874C8.05887 13.4584 8.78645 13.8473 9.57854 14.0049C10.3706 14.1624 11.1917 14.0816 11.9378 13.7725C12.6839 13.4635 13.3216 12.9401 13.7703 12.2686C14.219 11.5971 14.4585 10.8076 14.4585 10C14.4585 8.91704 14.0283 7.87843 13.2625 7.11266C12.4967 6.34688 11.4581 5.91668 10.3752 5.91668ZM10.3752 12.5833C9.86423 12.5833 9.36477 12.4318 8.93994 12.148C8.51511 11.8641 8.184 11.4607 7.98847 10.9886C7.79295 10.5166 7.74179 9.99714 7.84147 9.49603C7.94115 8.99491 8.18718 8.5346 8.54847 8.17332C8.90976 7.81203 9.37006 7.56599 9.87118 7.46631C10.3723 7.36664 10.8917 7.41779 11.3638 7.61332C11.8358 7.80885 12.2393 8.13996 12.5231 8.56479C12.807 8.98961 12.9585 9.48907 12.9585 10C12.9585 10.6852 12.6863 11.3422 12.2019 11.8267C11.7174 12.3112 11.0603 12.5833 10.3752 12.5833ZM19.2835 8.93334C18.957 8.26134 18.5299 7.64311 18.0168 7.10001C17.0506 6.07343 15.925 5.20954 14.6835 4.54168C13.3682 3.79175 11.8886 3.37679 10.3752 3.33334C8.07297 3.45388 5.87539 4.33291 4.12516 5.83334C3.35802 6.43729 2.67182 7.13749 2.0835 7.91668C1.84623 8.24412 1.63979 8.59283 1.46683 8.95834C1.30944 9.2839 1.22147 9.63863 1.2085 10C1.21798 10.3699 1.30604 10.7335 1.46683 11.0667C1.79331 11.7387 2.22045 12.3569 2.7335 12.9C3.69971 13.9266 4.8253 14.7905 6.06683 15.4583C7.38215 16.2083 8.8617 16.6232 10.3752 16.6667C12.6774 16.5461 14.8749 15.6671 16.6252 14.1667C17.4054 13.5732 18.1056 12.8814 18.7085 12.1083C18.9458 11.7809 19.1522 11.4322 19.3252 11.0667C19.4716 10.7303 19.5454 10.3668 19.5418 10C19.5323 9.63016 19.4443 9.26655 19.2835 8.93334ZM17.7585 10.3917C17.5032 10.8982 17.1747 11.3643 16.7835 11.775C15.9566 12.6599 14.9947 13.408 13.9335 13.9917C12.8481 14.6147 11.626 14.961 10.3752 15C8.45558 14.8841 6.62655 14.1437 5.16683 12.8917C4.51647 12.3787 3.93402 11.785 3.4335 11.125C3.26318 10.8952 3.11528 10.6497 2.99183 10.3917C2.9324 10.2681 2.89302 10.1359 2.87516 10C2.89302 9.86409 2.9324 9.73188 2.99183 9.60834C3.24713 9.10185 3.57566 8.63574 3.96683 8.22501C4.79372 7.34015 5.75565 6.59197 6.81683 6.00834C7.90222 5.38531 9.12428 5.03901 10.3752 5.00001C12.2947 5.11596 14.1238 5.85635 15.5835 7.10834C16.2339 7.62135 16.8163 8.215 17.3168 8.87501C17.4871 9.10478 17.635 9.35035 17.7585 9.60834C17.8179 9.73188 17.8573 9.86409 17.8752 10C17.8573 10.1359 17.8179 10.2681 17.7585 10.3917Z"
        fill="currentColor"
      />
      <path
        d="M10.3752 5.91668V7.41668V5.91668ZM14.4585 10H12.9585H14.4585ZM10.3752 12.5833V14.0833V12.5833ZM12.9585 10H14.4585H12.9585ZM19.2835 8.93334L20.6344 8.28146L20.6327 8.27786L19.2835 8.93334ZM18.0168 7.10001L16.9245 8.12807L16.9264 8.13007L18.0168 7.10001ZM14.6835 4.54168L13.9405 5.84476L13.9566 5.85392L13.9729 5.86267L14.6835 4.54168ZM10.3752 3.33334L10.4182 1.83396L10.3574 1.83222L10.2967 1.8354L10.3752 3.33334ZM4.12516 5.83334L5.05302 7.01193L5.07765 6.99255L5.10144 6.97215L4.12516 5.83334ZM2.0835 7.91668L0.886404 7.01281L0.877514 7.02459L0.868857 7.03653L2.0835 7.91668ZM1.46683 8.95834L2.81735 9.61123L2.82269 9.59994L1.46683 8.95834ZM1.2085 10L-0.290538 9.94619L-0.292194 9.99232L-0.291011 10.0385L1.2085 10ZM1.46683 11.0667L0.11588 11.7186L0.11763 11.7222L1.46683 11.0667ZM2.7335 12.9L3.82579 11.8719L3.8239 11.87L2.7335 12.9ZM6.06683 15.4583L6.80978 14.1553L6.79372 14.1461L6.77744 14.1373L6.06683 15.4583ZM10.3752 16.6667L10.3321 18.1661L10.3929 18.1678L10.4536 18.1646L10.3752 16.6667ZM16.6252 14.1667L15.7171 12.9728L15.6822 12.9993L15.6489 13.0279L16.6252 14.1667ZM18.7085 12.1083L19.8913 13.0308L19.9076 13.0099L19.9231 12.9885L18.7085 12.1083ZM19.3252 11.0667L20.681 11.7083L20.6911 11.687L20.7005 11.6654L19.3252 11.0667ZM19.5418 10L21.0418 9.98532L21.0416 9.97343L21.0413 9.96155L19.5418 10ZM17.7585 10.3917L19.0979 11.0669L19.1042 11.0544L19.1102 11.0419L17.7585 10.3917ZM16.7835 11.775L15.6973 10.7405L15.6924 10.7457L15.6875 10.7509L16.7835 11.775ZM13.9335 13.9917L13.2106 12.6773L13.1986 12.6839L13.1867 12.6908L13.9335 13.9917ZM10.3752 15L10.2847 16.4973L10.3533 16.5014L10.4219 16.4993L10.3752 15ZM5.16683 12.8917L6.14338 11.7531L6.11999 11.733L6.09581 11.714L5.16683 12.8917ZM3.4335 11.125L2.22846 12.0183L2.23335 12.0248L2.23831 12.0314L3.4335 11.125ZM2.99183 10.3917L4.34491 9.74424L4.34356 9.74144L2.99183 10.3917ZM2.87516 10L1.38794 9.80461L1.36227 10L1.38794 10.1954L2.87516 10ZM2.99183 9.60834L1.65237 8.93317L1.64612 8.94558L1.6401 8.9581L2.99183 9.60834ZM3.96683 8.22501L5.05304 9.25949L5.05794 9.25435L5.06278 9.24916L3.96683 8.22501ZM6.81683 6.00834L7.53969 7.32268L7.5517 7.31607L7.56358 7.30925L6.81683 6.00834ZM10.3752 5.00001L10.4656 3.50274L10.3971 3.4986L10.3284 3.50074L10.3752 5.00001ZM15.5835 7.10834L14.6069 8.24692L14.6303 8.26697L14.6545 8.28605L15.5835 7.10834ZM17.3168 8.87501L18.5219 7.98176L18.517 7.97517L18.512 7.96863L17.3168 8.87501ZM17.7585 9.60834L16.4054 10.2558L16.4068 10.2586L17.7585 9.60834ZM17.8752 10L19.3624 10.1954L19.3881 10L19.3624 9.80461L17.8752 10ZM10.3752 4.41668C9.27088 4.41668 8.1914 4.74413 7.27323 5.35764L8.93994 7.85205C9.36477 7.56819 9.86423 7.41668 10.3752 7.41668V4.41668ZM7.27323 5.35764C6.35505 5.97114 5.63942 6.84314 5.21684 7.86336L7.98847 9.01141C8.184 8.53937 8.51511 8.13591 8.93994 7.85205L7.27323 5.35764ZM5.21684 7.86336C4.79425 8.88358 4.68368 10.0062 4.89911 11.0893L7.84147 10.504C7.74179 10.0029 7.79295 9.48345 7.98847 9.01141L5.21684 7.86336ZM4.89911 11.0893C5.11455 12.1723 5.64631 13.1672 6.42715 13.948L8.54847 11.8267C8.18718 11.4654 7.94115 11.0051 7.84147 10.504L4.89911 11.0893ZM6.42715 13.948C7.20799 14.7289 8.20285 15.2606 9.28591 15.4761L9.87118 12.5337C9.37006 12.434 8.90976 12.188 8.54847 11.8267L6.42715 13.948ZM9.28591 15.4761C10.369 15.6915 11.4916 15.5809 12.5118 15.1583L11.3638 12.3867C10.8917 12.5822 10.3723 12.6334 9.87118 12.5337L9.28591 15.4761ZM12.5118 15.1583C13.532 14.7357 14.404 14.0201 15.0175 13.1019L12.5231 11.4352C12.2393 11.8601 11.8358 12.1912 11.3638 12.3867L12.5118 15.1583ZM15.0175 13.1019C15.631 12.1838 15.9585 11.1043 15.9585 10H12.9585C12.9585 10.5109 12.807 11.0104 12.5231 11.4352L15.0175 13.1019ZM15.9585 10C15.9585 8.51922 15.3703 7.09908 14.3232 6.052L12.2019 8.17332C12.6863 8.65779 12.9585 9.31487 12.9585 10H15.9585ZM14.3232 6.052C13.2761 5.00492 11.856 4.41668 10.3752 4.41668V7.41668C11.0603 7.41668 11.7174 7.68885 12.2019 8.17332L14.3232 6.052ZM10.3752 11.0833C10.1609 11.0833 9.95145 11.0198 9.77329 10.9008L8.10658 13.3952C8.77808 13.8439 9.56755 14.0833 10.3752 14.0833V11.0833ZM9.77329 10.9008C9.59514 10.7817 9.45629 10.6125 9.37429 10.4146L6.60265 11.5626C6.91171 12.3088 7.43508 12.9465 8.10658 13.3952L9.77329 10.9008ZM9.37429 10.4146C9.2923 10.2166 9.27084 9.99881 9.31264 9.78866L6.37029 9.20339C6.21273 9.99548 6.2936 10.8165 6.60265 11.5626L9.37429 10.4146ZM9.31264 9.78866C9.35445 9.57852 9.45762 9.38549 9.60913 9.23398L7.48781 7.11266C6.91675 7.68372 6.52785 8.4113 6.37029 9.20339L9.31264 9.78866ZM9.60913 9.23398C9.76064 9.08247 9.95367 8.97929 10.1638 8.93749L9.57854 5.99514C8.78645 6.15269 8.05887 6.54159 7.48781 7.11266L9.60913 9.23398ZM10.1638 8.93749C10.374 8.89569 10.5918 8.91715 10.7897 8.99914L11.9378 6.2275C11.1917 5.91844 10.3706 5.83758 9.57854 5.99514L10.1638 8.93749ZM10.7897 8.99914C10.9877 9.08114 11.1569 9.21999 11.2759 9.39814L13.7703 7.73143C13.3216 7.05993 12.6839 6.53656 11.9378 6.2275L10.7897 8.99914ZM11.2759 9.39814C11.395 9.5763 11.4585 9.78575 11.4585 10H14.4585C14.4585 9.1924 14.219 8.40293 13.7703 7.73143L11.2759 9.39814ZM11.4585 10C11.4585 10.2873 11.3444 10.5629 11.1412 10.766L13.2625 12.8874C14.0283 12.1216 14.4585 11.083 14.4585 10H11.4585ZM11.1412 10.766C10.938 10.9692 10.6625 11.0833 10.3752 11.0833V14.0833C11.4581 14.0833 12.4967 13.6531 13.2625 12.8874L11.1412 10.766ZM20.6327 8.27786C20.2395 7.46856 19.7251 6.72401 19.1072 6.06995L16.9264 8.13007C17.3347 8.56221 17.6745 9.05413 17.9343 9.58883L20.6327 8.27786ZM19.1091 6.07195C18.0323 4.92782 16.7778 3.96502 15.3941 3.22068L13.9729 5.86267C15.0723 6.45406 16.069 7.21903 16.9245 8.12807L19.1091 6.07195ZM15.4264 3.23859C13.8974 2.36684 12.1775 1.88446 10.4182 1.83396L10.3321 4.83273C11.5997 4.86911 12.8389 5.21666 13.9405 5.84476L15.4264 3.23859ZM10.2967 1.8354C7.66382 1.97325 5.15055 2.97856 3.14889 4.69453L5.10144 6.97215C6.60024 5.68727 8.48212 4.93451 10.4536 4.83129L10.2967 1.8354ZM3.1973 4.65475C2.32899 5.33834 1.55231 6.13087 0.886404 7.01281L3.28059 8.82054C3.79133 8.1441 4.38704 7.53624 5.05302 7.01193L3.1973 4.65475ZM0.868857 7.03653C0.577251 7.43896 0.323539 7.86753 0.110969 8.31675L2.82269 9.59994C2.95604 9.31813 3.1152 9.04927 3.29814 8.79682L0.868857 7.03653ZM0.116357 8.30548C-0.131539 8.81827 -0.270103 9.377 -0.290538 9.94619L2.70753 10.0538C2.71304 9.90027 2.75042 9.74954 2.8173 9.6112L0.116357 8.30548ZM-0.291011 10.0385C-0.276068 10.621 -0.137367 11.1937 0.115885 11.7186L2.81777 10.4148C2.74945 10.2732 2.71203 10.1187 2.708 9.96155L-0.291011 10.0385ZM0.11763 11.7222C0.510814 12.5315 1.02523 13.276 1.64309 13.9301L3.8239 11.87C3.41567 11.4378 3.0758 10.9459 2.81603 10.4112L0.11763 11.7222ZM1.64121 13.9281C2.71806 15.0722 3.97253 16.035 5.35622 16.7793L6.77744 14.1373C5.67807 13.546 4.68136 12.781 3.82579 11.872L1.64121 13.9281ZM5.32388 16.7614C6.85288 17.6332 8.57279 18.1156 10.3321 18.1661L10.4182 15.1673C9.15061 15.1309 7.91142 14.7834 6.80978 14.1553L5.32388 16.7614ZM10.4536 18.1646C13.0865 18.0268 15.5998 17.0215 17.6014 15.3055L15.6489 13.0279C14.1501 14.3128 12.2682 15.0655 10.2967 15.1687L10.4536 18.1646ZM17.5333 15.3606C18.4164 14.6888 19.209 13.9057 19.8913 13.0308L17.5257 11.1859C17.0023 11.857 16.3944 12.4576 15.7171 12.9728L17.5333 15.3606ZM19.9231 12.9885C20.2147 12.5861 20.4685 12.1575 20.681 11.7083L17.9693 10.4251C17.836 10.7069 17.6768 10.9757 17.4939 11.2282L19.9231 12.9885ZM20.7005 11.6654C20.9311 11.1356 21.0474 10.5631 21.0418 9.98532L18.0419 10.0147C18.0434 10.1706 18.0121 10.325 17.9498 10.4679L20.7005 11.6654ZM21.0413 9.96155C21.0264 9.379 20.8877 8.8063 20.6344 8.28146L17.9326 9.58522C18.0009 9.72681 18.0383 9.88131 18.0423 10.0385L21.0413 9.96155ZM16.419 9.7165C16.23 10.0914 15.9869 10.4365 15.6973 10.7405L17.8697 12.8095C18.3625 12.2921 18.7763 11.7049 19.0979 11.0669L16.419 9.7165ZM15.6875 10.7509C14.9689 11.5199 14.1329 12.1701 13.2106 12.6773L14.6564 15.306C15.8565 14.646 16.9443 13.7999 17.8794 12.7992L15.6875 10.7509ZM13.1867 12.6908C12.3149 13.1912 11.3332 13.4694 10.3284 13.5007L10.4219 16.4993C11.9189 16.4526 13.3813 16.0382 14.6802 15.2926L13.1867 12.6908ZM10.4656 13.5027C8.8726 13.4065 7.35475 12.7921 6.14338 11.7531L4.19028 14.0303C5.89834 15.4952 8.03855 16.3616 10.2847 16.4973L10.4656 13.5027ZM6.09581 11.714C5.54533 11.2798 5.05234 10.7773 4.62869 10.2186L2.23831 12.0314C2.8157 12.7928 3.48761 13.4776 4.23785 14.0694L6.09581 11.714ZM4.63853 10.2318C4.5253 10.079 4.42698 9.91576 4.34491 9.74424L1.63875 11.0391C1.80358 11.3836 2.00105 11.7115 2.22846 12.0183L4.63853 10.2318ZM4.34356 9.74144C4.35315 9.76136 4.3595 9.78268 4.36238 9.80461L1.38794 10.1954C1.42654 10.4892 1.51166 10.7749 1.6401 11.0419L4.34356 9.74144ZM4.36238 10.1954C4.3595 10.2173 4.35315 10.2387 4.34356 10.2586L1.6401 8.9581C1.51166 9.2251 1.42654 9.51085 1.38794 9.80461L4.36238 10.1954ZM4.33128 10.2835C4.52028 9.90858 4.76347 9.56354 5.05304 9.25949L2.88062 7.19053C2.38785 7.70794 1.97399 8.29512 1.65237 8.93317L4.33128 10.2835ZM5.06278 9.24916C5.78142 8.48014 6.61744 7.8299 7.53969 7.32268L6.09397 4.69401C4.89387 5.35405 3.80601 6.20016 2.87087 7.20086L5.06278 9.24916ZM7.56358 7.30925C8.43545 6.80878 9.4171 6.53061 10.4219 6.49928L10.3284 3.50074C8.83145 3.54741 7.36899 3.96184 6.07008 4.70743L7.56358 7.30925ZM10.2847 6.49728C11.8777 6.59351 13.3956 7.20793 14.6069 8.24692L16.56 5.96977C14.852 4.50478 12.7118 3.63842 10.4656 3.50274L10.2847 6.49728ZM14.6545 8.28605C15.205 8.72027 15.698 9.22275 16.1216 9.78139L18.512 7.96863C17.9346 7.20725 17.2627 6.52242 16.5125 5.93063L14.6545 8.28605ZM16.1118 9.76826C16.225 9.921 16.3233 10.0843 16.4054 10.2558L19.1116 8.96091C18.9467 8.61643 18.7493 8.28855 18.5219 7.98176L16.1118 9.76826ZM16.4068 10.2586C16.3972 10.2387 16.3908 10.2173 16.3879 10.1954L19.3624 9.80461C19.3238 9.51085 19.2387 9.2251 19.1102 8.9581L16.4068 10.2586ZM16.3879 9.80461C16.3908 9.78268 16.3972 9.76136 16.4068 9.74144L19.1102 11.0419C19.2387 10.7749 19.3238 10.4892 19.3624 10.1954L16.3879 9.80461Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_35_4325)"
      />
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.00033H4.16667M4.16667 5.00033H17.5M4.16667 5.00033V16.667C4.16667 17.109 4.34226 17.5329 4.65482 17.8455C4.96738 18.1581 5.39131 18.3337 5.83333 18.3337H14.1667C14.6087 18.3337 15.0326 18.1581 15.3452 17.8455C15.6577 17.5329 15.8333 17.109 15.8333 16.667V5.00033H4.16667ZM6.66667 5.00033V3.33366C6.66667 2.89163 6.84226 2.46771 7.15482 2.15515C7.46738 1.84259 7.89131 1.66699 8.33333 1.66699H11.6667C12.1087 1.66699 12.5326 1.84259 12.8452 2.15515C13.1577 2.46771 13.3333 2.89163 13.3333 3.33366V5.00033M8.33333 9.16699V14.167M11.6667 9.16699V14.167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6.08887L6 18.1245"
        stroke="#888FA1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6.08887L18 18.1245"
        stroke="#888FA1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.87565 5.8335H5.37565C4.93362 5.8335 4.5097 6.00909 4.19714 6.32165C3.88458 6.63421 3.70898 7.05814 3.70898 7.50016V15.0002C3.70898 15.4422 3.88458 15.8661 4.19714 16.1787C4.5097 16.4912 4.93362 16.6668 5.37565 16.6668H12.8757C13.3177 16.6668 13.7416 16.4912 14.0542 16.1787C14.3667 15.8661 14.5423 15.4422 14.5423 15.0002V12.5002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.87549 12.5003H10.3755L17.4588 5.41694C17.7903 5.08542 17.9766 4.63578 17.9766 4.16694C17.9766 3.6981 17.7903 3.24846 17.4588 2.91694C17.1273 2.58542 16.6777 2.39917 16.2088 2.39917C15.74 2.39917 15.2903 2.58542 14.9588 2.91694L7.87549 10.0003V12.5003Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7109 4.16675L16.2109 6.66675"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Hide = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.12549 3.125L16.6255 16.875"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4767 12.3127C11.9032 12.838 11.1529 13.1281 10.3752 13.1252C9.74442 13.1251 9.12847 12.9342 8.60828 12.5775C8.08809 12.2208 7.688 11.7151 7.46062 11.1267C7.23324 10.5384 7.18921 9.89506 7.33431 9.28124C7.47941 8.66743 7.80685 8.11189 8.27359 7.68765"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.15674 5.35922C2.96924 6.9686 1.62549 9.99985 1.62549 9.99985C1.62549 9.99985 4.12549 15.6248 10.3755 15.6248C11.84 15.6368 13.2862 15.2993 14.5942 14.6405"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6729 13.211C18.376 11.6875 19.126 10 19.126 10C19.126 10 16.626 4.37502 10.376 4.37502C9.83415 4.37395 9.29318 4.41838 8.75879 4.50783"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9614 6.92969C11.626 7.05561 12.2316 7.39427 12.6868 7.89457C13.142 8.39487 13.4221 9.02965 13.4849 9.70313"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = ({ color = "currentColor" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="dynamic_colors"
        d="M16.7202 15.4364L16.3083 15.9603L16.78 16.4309L21.1794 20.8203C21.1795 20.8204 21.1797 20.8206 21.1798 20.8207C21.2272 20.8683 21.2539 20.9328 21.2539 21C21.2539 21.0674 21.2271 21.132 21.1794 21.1797L21.7098 21.71L21.1794 21.1797C21.1318 21.2273 21.0672 21.2541 20.9998 21.2541C20.9325 21.2541 20.868 21.2275 20.8204 21.18C20.8203 21.1799 20.8202 21.1798 20.8201 21.1797L16.4307 16.7803L15.96 16.3085L15.4362 16.7204C14.172 17.7145 12.6096 18.2534 11.0014 18.25H10.9998C9.56585 18.25 8.16413 17.8248 6.97188 17.0282C5.77962 16.2315 4.85037 15.0992 4.30163 13.7745C3.7529 12.4497 3.60932 10.992 3.88907 9.5856C4.16881 8.17924 4.8593 6.88741 5.87324 5.87348C6.88717 4.85955 8.17899 4.16905 9.58536 3.88931C10.9917 3.60957 12.4495 3.75314 13.7742 4.30188C15.099 4.85061 16.2313 5.77986 17.0279 6.97212C17.8246 8.16438 18.2498 9.56609 18.2498 11L18.2498 11.0016C18.2532 12.6098 17.7143 14.1722 16.7202 15.4364ZM6.23539 15.8262L7.50976 17.0724V16.7746C8.55363 17.4064 9.75862 17.7489 10.9991 17.75V17.75L11.0054 17.75C12.5681 17.7382 14.0782 17.1847 15.2783 16.1837C16.4783 15.1827 17.2939 13.7964 17.5858 12.2612C17.8778 10.726 17.628 9.13703 16.8791 7.76545C16.1302 6.39386 14.9287 5.32461 13.4794 4.74011C12.0301 4.15561 10.4229 4.09208 8.932 4.56036C7.4411 5.02863 6.15886 5.9997 5.30405 7.3079C4.44924 8.61609 4.07482 10.1804 4.24467 11.7338C4.41451 13.2873 5.1181 14.7337 6.23539 15.8262Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AddIcon = ({ color = "white" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.75V14.25M3.75 9H14.25"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 15.1875L9.5 4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5625 9.5625L9.5 4.5L4.4375 9.5625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6875 2.25L3.3125 2.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 2.75V13.4375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.9375 8.375L9 13.4375L14.0625 8.375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.8125 15.6875H15.1875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.06268 16.0835L3.56268 10.5835C3.47934 10.5001 3.42018 10.4099 3.38518 10.3126C3.35018 10.2154 3.33295 10.1112 3.33351 10.0001C3.33351 9.88902 3.35101 9.78485 3.38601 9.68763C3.42101 9.59041 3.4799 9.50013 3.56268 9.4168L9.06268 3.9168C9.21545 3.76402 9.40656 3.6843 9.63601 3.67763C9.86545 3.67097 10.0632 3.75069 10.2293 3.9168C10.396 4.06958 10.483 4.26069 10.4902 4.49013C10.4974 4.71958 10.4174 4.91735 10.2502 5.08347L6.16684 9.1668H15.4793C15.7155 9.1668 15.9135 9.2468 16.0735 9.4068C16.2335 9.5668 16.3132 9.76458 16.3127 10.0001C16.3127 10.2362 16.233 10.4343 16.0735 10.5943C15.9141 10.7543 15.716 10.834 15.4793 10.8335H6.16684L10.2502 14.9168C10.403 15.0696 10.483 15.264 10.4902 15.5001C10.4974 15.7362 10.4174 15.9307 10.2502 16.0835C10.0974 16.2501 9.90295 16.3335 9.66684 16.3335C9.43073 16.3335 9.22934 16.2501 9.06268 16.0835Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DeleteIcon = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.00008H4.16667M4.16667 5.00008H17.5M4.16667 5.00008V16.6667C4.16667 17.1088 4.34226 17.5327 4.65482 17.8453C4.96738 18.1578 5.39131 18.3334 5.83333 18.3334H14.1667C14.6087 18.3334 15.0326 18.1578 15.3452 17.8453C15.6577 17.5327 15.8333 17.1088 15.8333 16.6667V5.00008H4.16667ZM6.66667 5.00008V3.33341C6.66667 2.89139 6.84226 2.46746 7.15482 2.1549C7.46738 1.84234 7.89131 1.66675 8.33333 1.66675H11.6667C12.1087 1.66675 12.5326 1.84234 12.8452 2.1549C13.1577 2.46746 13.3333 2.89139 13.3333 3.33341V5.00008M8.33333 9.16675V14.1667M11.6667 9.16675V14.1667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronUpIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7.5L6.00033 4.5L3.00066 7.5"
        stroke="#7B7B80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDownIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4.5L5.99967 7.5L8.99934 4.5"
        stroke="#7B7B80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = ({ color = "white" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.75V14.25M3.75 9H14.25"
        stroke={color ? color : "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RevokeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M5.625 9.5625L2.25 6.1875L5.625 2.8125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 14.0625H11.8125C12.8568 14.0625 13.8583 13.6477 14.5967 12.9092C15.3352 12.1708 15.75 11.1693 15.75 10.125V10.125C15.75 9.08071 15.3352 8.07919 14.5967 7.34077C13.8583 6.60234 12.8568 6.1875 11.8125 6.1875H2.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ActionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M3.5 10.5C3.5 8.7761 4.18482 7.1228 5.40381 5.90381C6.6228 4.68482 8.2761 4 10 4C11.7239 4 13.3772 4.68482 14.5962 5.90381C15.8152 7.1228 16.5 8.7761 16.5 10.5C16.5 10.6989 16.579 10.8897 16.7197 11.0303C16.8603 11.171 17.0511 11.25 17.25 11.25C17.4489 11.25 17.6397 11.171 17.7803 11.0303C17.921 10.8897 18 10.6989 18 10.5C18 8.91775 17.5308 7.37103 16.6518 6.05544C15.7727 4.73985 14.5233 3.71447 13.0615 3.10897C11.5997 2.50347 9.99113 2.34504 8.43928 2.65372C6.88743 2.9624 5.46197 3.72433 4.34315 4.84315C3.22433 5.96197 2.4624 7.38743 2.15372 8.93928C1.84504 10.4911 2.00347 12.0997 2.60897 13.5615C3.21447 15.0233 4.23985 16.2727 5.55544 17.1518C6.87103 18.0308 8.41775 18.5 10 18.5C10.1989 18.5 10.3897 18.421 10.5303 18.2803C10.671 18.1397 10.75 17.9489 10.75 17.75C10.75 17.5511 10.671 17.3603 10.5303 17.2197C10.3897 17.079 10.1989 17 10 17C8.2761 17 6.6228 16.3152 5.40381 15.0962C4.18482 13.8772 3.5 12.2239 3.5 10.5Z"
        fill="#335CA4"
      />
      <path
        d="M10 12C10.3978 12 10.7794 11.842 11.0607 11.5607C11.342 11.2794 11.5 10.8978 11.5 10.5C11.5 10.1022 11.342 9.72064 11.0607 9.43934C10.7794 9.15804 10.3978 9 10 9C9.60218 9 9.22064 9.15804 8.93934 9.43934C8.65804 9.72064 8.5 10.1022 8.5 10.5C8.5 10.8978 8.65804 11.2794 8.93934 11.5607C9.22064 11.842 9.60218 12 10 12ZM13.573 17.823L10.677 14.927C10.6537 14.9038 10.6352 14.8762 10.6226 14.8458C10.61 14.8154 10.6036 14.7829 10.6036 14.75C10.6036 14.7171 10.61 14.6846 10.6226 14.6542C10.6352 14.6238 10.6537 14.5962 10.677 14.573L13.573 11.677C13.608 11.6419 13.6525 11.6181 13.7011 11.6084C13.7497 11.5987 13.8 11.6036 13.8457 11.6226C13.8915 11.6416 13.9305 11.6737 13.958 11.7149C13.9855 11.7561 14.0001 11.8045 14 11.854V14H17.25C17.4489 14 17.6397 14.079 17.7803 14.2197C17.921 14.3603 18 14.5511 18 14.75C18 14.9489 17.921 15.1397 17.7803 15.2803C17.6397 15.421 17.4489 15.5 17.25 15.5H14V17.646C14.0001 17.6955 13.9855 17.7439 13.958 17.7851C13.9305 17.8263 13.8915 17.8584 13.8457 17.8774C13.8 17.8964 13.7497 17.9013 13.7011 17.8916C13.6525 17.8819 13.608 17.8581 13.573 17.823Z"
        fill="#335CA4"
      />
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.5003 6.24992L5.99253 12.8671C5.77708 13.1049 5.66132 13.4164 5.66922 13.7372C5.67711 14.058 5.80806 14.3634 6.03495 14.5903C6.26184 14.8172 6.5673 14.9481 6.88807 14.956C7.20884 14.9639 7.52037 14.8482 7.75815 14.6327L15.516 6.76554C15.9469 6.28998 16.1784 5.66693 16.1626 5.02538C16.1468 4.38383 15.8849 3.77293 15.4311 3.31915C14.9773 2.86537 14.3664 2.60347 13.7249 2.58767C13.0833 2.57188 12.4603 2.80339 11.9847 3.23429L4.2269 11.1015C3.52449 11.8039 3.12988 12.7566 3.12988 13.7499C3.12988 14.7433 3.52449 15.6959 4.2269 16.3984C4.92931 17.1008 5.88198 17.4954 6.87534 17.4954C7.8687 17.4954 8.82137 17.1008 9.52378 16.3984L15.9378 9.99992"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ActiveStepperIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 18.3337C11.0949 18.3351 12.1789 18.1202 13.1902 17.7013C14.2014 17.2824 15.1199 16.6678 15.8928 15.8928C16.6678 15.1199 17.2824 14.2014 17.7013 13.1902C18.1202 12.1789 18.3351 11.0949 18.3337 10.0003C18.3351 8.90578 18.1201 7.82174 17.7013 6.81051C17.2824 5.79928 16.6678 4.88079 15.8928 4.10783C15.1199 3.33284 14.2014 2.71825 13.1902 2.29937C12.1789 1.88049 11.0949 1.66558 10.0003 1.667C8.90578 1.6656 7.82174 1.88052 6.81051 2.2994C5.79928 2.71828 4.88079 3.33286 4.10783 4.10783C3.33286 4.88079 2.71828 5.79928 2.2994 6.81051C1.88052 7.82174 1.6656 8.90578 1.667 10.0003C1.66558 11.0949 1.88049 12.1789 2.29937 13.1902C2.71825 14.2014 3.33284 15.1199 4.10783 15.8928C4.88079 16.6678 5.79928 17.2824 6.81051 17.7013C7.82174 18.1201 8.90578 18.3351 10.0003 18.3337Z"
        fill="currentColor"
      />
      <path
        d="M6.66699 10L9.16699 12.5L14.167 7.5"
        stroke="#ECE6FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PendingStepperIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1429_2790)">
        <path
          d="M10.0003 18.3337C11.0949 18.3351 12.1789 18.1202 13.1902 17.7013C14.2014 17.2824 15.1199 16.6678 15.8928 15.8928C16.6678 15.1199 17.2824 14.2014 17.7013 13.1902C18.1202 12.1789 18.3351 11.0949 18.3337 10.0003C18.3351 8.90578 18.1201 7.82174 17.7013 6.81051C17.2824 5.79928 16.6678 4.88079 15.8928 4.10783C15.1199 3.33284 14.2014 2.71825 13.1902 2.29937C12.1789 1.88049 11.0949 1.66558 10.0003 1.667C8.90578 1.6656 7.82174 1.88052 6.81051 2.2994C5.79928 2.71828 4.88079 3.33286 4.10783 4.10783C3.33286 4.88079 2.71828 5.79928 2.2994 6.81051C1.88052 7.82174 1.6656 8.90578 1.667 10.0003C1.66558 11.0949 1.88049 12.1789 2.29937 13.1902C2.71825 14.2014 3.33284 15.1199 4.10783 15.8928C4.88079 16.6678 5.79928 17.2824 6.81051 17.7013C7.82174 18.1201 8.90578 18.3351 10.0003 18.3337Z"
          stroke="#C2C2C4"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M6.66699 10L9.16699 12.5L14.167 7.5"
          stroke="#D1D1D3"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1429_2790">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CompletedStepperIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 18.3337C11.0949 18.3351 12.1789 18.1202 13.1902 17.7013C14.2014 17.2824 15.1199 16.6678 15.8928 15.8928C16.6678 15.1199 17.2824 14.2014 17.7013 13.1902C18.1202 12.1789 18.3351 11.0949 18.3337 10.0003C18.3351 8.90578 18.1201 7.82174 17.7013 6.81051C17.2824 5.79928 16.6678 4.88079 15.8928 4.10783C15.1199 3.33284 14.2014 2.71825 13.1902 2.29937C12.1789 1.88049 11.0949 1.66558 10.0003 1.667C8.90578 1.6656 7.82174 1.88052 6.81051 2.2994C5.79928 2.71828 4.88079 3.33286 4.10783 4.10783C3.33286 4.88079 2.71828 5.79928 2.2994 6.81051C1.88052 7.82174 1.6656 8.90578 1.667 10.0003C1.66558 11.0949 1.88049 12.1789 2.29937 13.1902C2.71825 14.2014 3.33284 15.1199 4.10783 15.8928C4.88079 16.6678 5.79928 17.2824 6.81051 17.7013C7.82174 18.1201 8.90578 18.3351 10.0003 18.3337Z"
        fill="#3A3A41"
      />
      <path
        d="M6.66699 10L9.16699 12.5L14.167 7.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronLeft = ({ stroke = "#A4A4A8" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Main Icons">
        <path
          id="Vector"
          d="M10 13L5 8L10 3"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ChevronRight = ({ stroke = "#00338D" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3L11 8L6 13"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="pointer-events-none"
    >
      <path
        d="M8.4375 10L16.875 10"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 10L5.3125 10"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4375 10C8.4375 9.13706 7.73794 8.4375 6.875 8.4375C6.01205 8.4375 5.3125 9.13706 5.3125 10C5.3125 10.8629 6.01206 11.5625 6.875 11.5625C7.73794 11.5625 8.4375 10.8629 8.4375 10Z"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6875 4.375L16.875 4.375"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 4.375L11.5625 4.375"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6875 4.375C14.6875 3.51206 13.9879 2.8125 13.125 2.8125C12.2621 2.8125 11.5625 3.51206 11.5625 4.375C11.5625 5.23794 12.2621 5.9375 13.125 5.9375C13.9879 5.9375 14.6875 5.23794 14.6875 4.375Z"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 15.625L16.875 15.625"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 15.625L9.0625 15.625"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 15.625C12.1875 14.7621 11.4879 14.0625 10.625 14.0625C9.76205 14.0625 9.0625 14.7621 9.0625 15.625C9.0625 16.4879 9.76206 17.1875 10.625 17.1875C11.4879 17.1875 12.1875 16.4879 12.1875 15.625Z"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ColumnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.375 16.25L5.375 3.75C5.375 3.40482 5.15882 3.125 4.89214 3.125H2.47786C2.21118 3.125 1.995 3.40482 1.995 3.75L1.995 16.25C1.995 16.5952 2.21118 16.875 2.47786 16.875H4.89214C5.15882 16.875 5.375 16.5952 5.375 16.25Z"
        stroke="#00338D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 16.25V3.75C11.75 3.40482 11.5338 3.125 11.2671 3.125H8.85286C8.58618 3.125 8.37 3.40482 8.37 3.75V16.25C8.37 16.5952 8.58618 16.875 8.85286 16.875H11.2671C11.5338 16.875 11.75 16.5952 11.75 16.25Z"
        stroke="#00338D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.125 16.25V3.75C18.125 3.40482 17.9088 3.125 17.6421 3.125H15.2279C14.9612 3.125 14.745 3.40482 14.745 3.75V16.25C14.745 16.5952 14.9612 16.875 15.2279 16.875H17.6421C17.9088 16.875 18.125 16.5952 18.125 16.25Z"
        stroke="#00338D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NotificationIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.0361 7.31258C4.03516 6.64572 4.16605 5.98527 4.42125 5.36925C4.67644 4.75324 5.05088 4.19385 5.523 3.72329C5.99513 3.25273 6.55561 2.8803 7.17217 2.62747C7.78872 2.37463 8.44916 2.24637 9.11546 2.25008C11.8975 2.27117 14.1246 4.58445 14.1246 7.37586V7.87508C14.1246 10.3923 14.6515 11.8548 15.1151 12.6563C15.1644 12.7417 15.1904 12.8385 15.1904 12.9371C15.1905 13.0357 15.1647 13.1325 15.1156 13.218C15.0665 13.3034 14.9959 13.3745 14.9107 13.424C14.8255 13.4735 14.7289 13.4997 14.6304 13.5001H3.53027C3.43178 13.4997 3.33511 13.4735 3.24995 13.424C3.16478 13.3745 3.09411 13.3034 3.04502 13.218C2.99592 13.1325 2.97013 13.0357 2.97022 12.9371C2.9703 12.8385 2.99627 12.7417 3.04551 12.6563C3.50919 11.8548 4.0361 10.3923 4.0361 7.87508V7.31258Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83154 13.5V14.0625C6.83154 14.6592 7.0684 15.2315 7.49 15.6535C7.91161 16.0754 8.48343 16.3125 9.07967 16.3125C9.67591 16.3125 10.2477 16.0754 10.6693 15.6535C11.0909 15.2315 11.3278 14.6592 11.3278 14.0625V13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerticalDotsActionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7998 18.3C10.7998 17.9022 10.9578 17.5207 11.2391 17.2394C11.5204 16.9581 11.902 16.8 12.2998 16.8C12.6976 16.8 13.0792 16.9581 13.3605 17.2394C13.6418 17.5207 13.7998 17.9022 13.7998 18.3C13.7998 18.6979 13.6418 19.0794 13.3605 19.3607C13.0792 19.642 12.6976 19.8 12.2998 19.8C11.902 19.8 11.5204 19.642 11.2391 19.3607C10.9578 19.0794 10.7998 18.6979 10.7998 18.3ZM10.7998 12.3C10.7998 11.9022 10.9578 11.5207 11.2391 11.2394C11.5204 10.9581 11.902 10.8 12.2998 10.8C12.6976 10.8 13.0792 10.9581 13.3605 11.2394C13.6418 11.5207 13.7998 11.9022 13.7998 12.3C13.7998 12.6979 13.6418 13.0794 13.3605 13.3607C13.0792 13.642 12.6976 13.8 12.2998 13.8C11.902 13.8 11.5204 13.642 11.2391 13.3607C10.9578 13.0794 10.7998 12.6979 10.7998 12.3ZM10.7998 6.30005C10.7998 5.90222 10.9578 5.52069 11.2391 5.23939C11.5204 4.95808 11.902 4.80005 12.2998 4.80005C12.6976 4.80005 13.0792 4.95808 13.3605 5.23939C13.6418 5.52069 13.7998 5.90222 13.7998 6.30005C13.7998 6.69787 13.6418 7.0794 13.3605 7.36071C13.0792 7.64201 12.6976 7.80005 12.2998 7.80005C11.902 7.80005 11.5204 7.64201 11.2391 7.36071C10.9578 7.0794 10.7998 6.69787 10.7998 6.30005Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GenerateReportIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="pointer-events-none"
    >
      <path
        d="M15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5Z"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 2.5V6.875H16.25"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.8125 12.1875L10 14.375L12.1875 12.1875"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.375V14.375"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SuccessDownload = () => {
  return (
    <svg
      width="105"
      height="93"
      viewBox="0 0 105 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.0727 42.1574C106.808 68.2229 82.8593 68.9575 59.4296 76.8096C35.9999 84.6618 5.66371 84.698 5.14936 53.595C11.6721 20.961 30.8829 54.9495 54.3126 47.0973C77.7423 39.2452 82.6285 24.2347 98.0727 42.1574Z"
        fill="#E9F8E7"
      />
      <path
        d="M53 62.3333C56.7215 62.3381 60.4072 61.6075 63.8454 60.1833C67.2836 58.7591 70.4065 56.6694 73.0345 54.0345C75.6694 51.4065 77.7591 48.2836 79.1833 44.8454C80.6075 41.4072 81.3381 37.7215 81.3333 34C81.3381 30.2785 80.6073 26.5928 79.1832 23.1546C77.759 19.7164 75.6694 16.5936 73.0345 13.9655C70.4065 11.3305 67.2836 9.2409 63.8454 7.8167C60.4072 6.39251 56.7215 5.66183 53 5.66665C49.2785 5.66191 45.5928 6.39262 42.1546 7.81681C38.7164 9.241 35.5936 11.3306 32.9655 13.9655C30.3306 16.5936 28.241 19.7164 26.8168 23.1546C25.3926 26.5928 24.6619 30.2785 24.6666 34C24.6618 37.7215 25.3925 41.4072 26.8167 44.8454C28.2409 48.2836 30.3305 51.4065 32.9655 54.0345C35.5936 56.6694 38.7164 58.759 42.1546 60.1832C45.5928 61.6073 49.2785 62.3381 53 62.3333Z"
        stroke="#1EBB10"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M41.6666 34L50.1666 42.5L67.1666 25.5"
        stroke="#1EBB10"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IssueIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87549 10C3.87549 8.2761 4.56031 6.6228 5.7793 5.40381C6.99828 4.18482 8.65158 3.5 10.3755 3.5C12.0994 3.5 13.7527 4.18482 14.9717 5.40381C16.1907 6.6228 16.8755 8.2761 16.8755 10C16.8755 10.1989 16.9545 10.3897 17.0952 10.5303C17.2358 10.671 17.4266 10.75 17.6255 10.75C17.8244 10.75 18.0152 10.671 18.1558 10.5303C18.2965 10.3897 18.3755 10.1989 18.3755 10C18.3755 8.41775 17.9063 6.87103 17.0272 5.55544C16.1482 4.23985 14.8988 3.21447 13.437 2.60897C11.9752 2.00347 10.3666 1.84504 8.81477 2.15372C7.26292 2.4624 5.83746 3.22433 4.71864 4.34315C3.59982 5.46197 2.83789 6.88743 2.52921 8.43928C2.22053 9.99113 2.37895 11.5997 2.98446 13.0615C3.58996 14.5233 4.61534 15.7727 5.93093 16.6518C7.24652 17.5308 8.79324 18 10.3755 18C10.5744 18 10.7652 17.921 10.9058 17.7803C11.0465 17.6397 11.1255 17.4489 11.1255 17.25C11.1255 17.0511 11.0465 16.8603 10.9058 16.7197C10.7652 16.579 10.5744 16.5 10.3755 16.5C8.65158 16.5 6.99828 15.8152 5.7793 14.5962C4.56031 13.3772 3.87549 11.7239 3.87549 10Z"
        fill="currentColor"
      />
      <path
        d="M10.3755 11.5C10.7733 11.5 11.1548 11.342 11.4361 11.0607C11.7175 10.7794 11.8755 10.3978 11.8755 10C11.8755 9.60218 11.7175 9.22064 11.4361 8.93934C11.1548 8.65804 10.7733 8.5 10.3755 8.5C9.97766 8.5 9.59613 8.65804 9.31483 8.93934C9.03352 9.22064 8.87549 9.60218 8.87549 10C8.87549 10.3978 9.03352 10.7794 9.31483 11.0607C9.59613 11.342 9.97766 11.5 10.3755 11.5ZM13.9485 17.323L11.0525 14.427C11.0292 14.4038 11.0107 14.3762 10.9981 14.3458C10.9855 14.3154 10.979 14.2829 10.979 14.25C10.979 14.2171 10.9855 14.1846 10.9981 14.1542C11.0107 14.1238 11.0292 14.0962 11.0525 14.073L13.9485 11.177C13.9835 11.1419 14.028 11.1181 14.0766 11.1084C14.1251 11.0987 14.1755 11.1036 14.2212 11.1226C14.267 11.1416 14.306 11.1737 14.3335 11.2149C14.361 11.2561 14.3756 11.3045 14.3755 11.354V13.5H17.6255C17.8244 13.5 18.0152 13.579 18.1558 13.7197C18.2965 13.8603 18.3755 14.0511 18.3755 14.25C18.3755 14.4489 18.2965 14.6397 18.1558 14.7803C18.0152 14.921 17.8244 15 17.6255 15H14.3755V17.146C14.3756 17.1955 14.361 17.2439 14.3335 17.2851C14.306 17.3263 14.267 17.3584 14.2212 17.3774C14.1755 17.3964 14.1251 17.4013 14.0766 17.3916C14.028 17.3819 13.9835 17.3581 13.9485 17.323Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const IssueDarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.89999 12C2.89999 9.58652 3.85874 7.2719 5.56532 5.56532C7.2719 3.85874 9.58652 2.89999 12 2.89999C14.4135 2.89999 16.7281 3.85874 18.4347 5.56532C20.1412 7.2719 21.1 9.58652 21.1 12C21.1 12.2785 21.2106 12.5455 21.4075 12.7425C21.6044 12.9394 21.8715 13.05 22.15 13.05C22.4285 13.05 22.6955 12.9394 22.8925 12.7425C23.0894 12.5455 23.2 12.2785 23.2 12C23.2 9.78484 22.5431 7.61944 21.3125 5.77761C20.0818 3.93578 18.3326 2.50024 16.286 1.65254C14.2395 0.804841 11.9876 0.583043 9.81498 1.0152C7.64239 1.44735 5.64675 2.51405 4.0804 4.0804C2.51405 5.64675 1.44735 7.64239 1.0152 9.81498C0.583043 11.9876 0.804841 14.2395 1.65254 16.286C2.50024 18.3326 3.93578 20.0818 5.77761 21.3125C7.61944 22.5431 9.78484 23.2 12 23.2C12.2785 23.2 12.5455 23.0894 12.7425 22.8925C12.9394 22.6955 13.05 22.4285 13.05 22.15C13.05 21.8715 12.9394 21.6044 12.7425 21.4075C12.5455 21.2106 12.2785 21.1 12 21.1C9.58652 21.1 7.2719 20.1412 5.56532 18.4347C3.85874 16.7281 2.89999 14.4135 2.89999 12Z"
        fill="#18181B"
      />
      <path
        d="M12 14.1C12.5569 14.1 13.0911 13.8787 13.4849 13.4849C13.8787 13.0911 14.1 12.5569 14.1 12C14.1 11.443 13.8787 10.9089 13.4849 10.515C13.0911 10.1212 12.5569 9.89996 12 9.89996C11.443 9.89996 10.9089 10.1212 10.5151 10.515C10.1212 10.9089 9.89999 11.443 9.89999 12C9.89999 12.5569 10.1212 13.0911 10.5151 13.4849C10.9089 13.8787 11.443 14.1 12 14.1ZM17.0022 22.2522L12.9478 18.1978C12.9152 18.1653 12.8893 18.1266 12.8717 18.0841C12.8541 18.0416 12.845 17.996 12.845 17.95C12.845 17.9039 12.8541 17.8583 12.8717 17.8158C12.8893 17.7733 12.9152 17.7347 12.9478 17.7022L17.0022 13.6478C17.0511 13.5987 17.1136 13.5653 17.1815 13.5517C17.2495 13.5381 17.32 13.5451 17.384 13.5716C17.4481 13.5982 17.5028 13.6431 17.5412 13.7008C17.5797 13.7585 17.6001 13.8262 17.6 13.8956V16.9H22.15C22.4285 16.9 22.6955 17.0106 22.8925 17.2075C23.0894 17.4044 23.2 17.6715 23.2 17.95C23.2 18.2284 23.0894 18.4955 22.8925 18.6924C22.6955 18.8893 22.4285 19 22.15 19H17.6V22.0044C17.6001 22.0737 17.5797 22.1415 17.5412 22.1991C17.5028 22.2568 17.4481 22.3018 17.384 22.3283C17.32 22.3549 17.2495 22.3618 17.1815 22.3482C17.1136 22.3347 17.0511 22.3012 17.0022 22.2522Z"
        fill="#18181B"
      />
    </svg>
  );
};

export const DeleteIconPop = () => {
  return (
    <svg
      width="105"
      height="84"
      viewBox="0 0 105 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M98.0727 33.1574C106.808 59.2229 82.8593 59.9575 59.4296 67.8096C35.9999 75.6618 5.66371 75.698 5.14936 44.595C11.6721 11.961 30.8829 45.9495 54.3126 38.0973C77.7423 30.2452 82.6285 15.2347 98.0727 33.1574Z"
        fill="#FFEBEB"
      />
      <path
        d="M32 14H36.6667M36.6667 14H74M36.6667 14V46.6666C36.6667 47.9043 37.1583 49.0913 38.0335 49.9665C38.9087 50.8416 40.0957 51.3333 41.3333 51.3333H64.6667C65.9043 51.3333 67.0913 50.8416 67.9665 49.9665C68.8417 49.0913 69.3333 47.9043 69.3333 46.6666V14H36.6667ZM43.6667 14V9.33329C43.6667 8.09562 44.1583 6.90863 45.0335 6.03346C45.9087 5.15829 47.0957 4.66663 48.3333 4.66663H57.6667C58.9043 4.66663 60.0913 5.15829 60.9665 6.03346C61.8417 6.90863 62.3333 8.09562 62.3333 9.33329V14M48.3333 25.6666V39.6666M57.6667 25.6666V39.6666"
        stroke="#FD3A3A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeveloperIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.13013 7.71875L2.19263 11L6.13013 14.2812"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6301 7.71875L20.5676 11L16.6301 14.2812"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0051 3.78125L8.75513 18.2188"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3488 17.5626V13.6251C13.3488 13.451 13.2797 13.2841 13.1566 13.161C13.0336 13.038 12.8666 12.9688 12.6926 12.9688H10.0676C9.89355 12.9688 9.72663 13.038 9.60356 13.161C9.48049 13.2841 9.41135 13.451 9.41135 13.6251V17.5626C9.41135 17.7366 9.34221 17.9036 9.21914 18.0266C9.09606 18.1497 8.92914 18.2188 8.7551 18.2188H4.8176C4.64355 18.2188 4.47663 18.1497 4.35356 18.0266C4.23049 17.9036 4.16135 17.7366 4.16135 17.5626V9.97469C4.16282 9.88387 4.18244 9.79427 4.21907 9.71115C4.2557 9.62803 4.30859 9.55308 4.37463 9.49071L10.9371 3.52704C11.0581 3.41636 11.2161 3.35498 11.3801 3.35498C11.5441 3.35498 11.7021 3.41636 11.8231 3.52704L18.3856 9.49071C18.4516 9.55308 18.5045 9.62803 18.5411 9.71115C18.5777 9.79427 18.5974 9.88387 18.5988 9.97469V17.5626C18.5988 17.7366 18.5297 17.9036 18.4066 18.0266C18.2836 18.1497 18.1166 18.2188 17.9426 18.2188H14.0051C13.831 18.2188 13.6641 18.1497 13.5411 18.0266C13.418 17.9036 13.3488 17.7366 13.3488 17.5626Z"
        stroke="#18181B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ManageTemplateIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6614 18.875H5.47388C5.29983 18.875 5.13291 18.8059 5.00984 18.6828C4.88677 18.5597 4.81763 18.3928 4.81763 18.2188V6.40625C4.81763 6.2322 4.88677 6.06528 5.00984 5.94221C5.13291 5.81914 5.29983 5.75 5.47388 5.75H12.0364L15.3176 9.03125V18.2188C15.3176 18.3928 15.2485 18.5597 15.1254 18.6828C15.0023 18.8059 14.8354 18.875 14.6614 18.875Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44263 5.75V3.78125C7.44263 3.6072 7.51177 3.44028 7.63484 3.31721C7.75791 3.19414 7.92483 3.125 8.09888 3.125H14.6614L17.9426 6.40625V15.5938C17.9426 15.7678 17.8735 15.9347 17.7504 16.0578C17.6273 16.1809 17.4604 16.25 17.2864 16.25H15.3176"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09888 12.9688H12.0364"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09888 15.5938H12.0364"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DappManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11.375 12.9688C12.4623 12.9688 13.3438 12.0873 13.3438 11C13.3438 9.91269 12.4623 9.03125 11.375 9.03125C10.2877 9.03125 9.40625 9.91269 9.40625 11C9.40625 12.0873 10.2877 12.9688 11.375 12.9688Z"
        stroke="#00338D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 7.0625C9.83731 7.0625 10.7188 6.18106 10.7188 5.09375C10.7188 4.00644 9.83731 3.125 8.75 3.125C7.66269 3.125 6.78125 4.00644 6.78125 5.09375C6.78125 6.18106 7.66269 7.0625 8.75 7.0625Z"
        stroke="#18181B"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2812 11C18.3686 11 19.25 10.1186 19.25 9.03125C19.25 7.94394 18.3686 7.0625 17.2812 7.0625C16.1939 7.0625 15.3125 7.94394 15.3125 9.03125C15.3125 10.1186 16.1939 11 17.2812 11Z"
        stroke="#18181B"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2812 17.5625C18.3686 17.5625 19.25 16.6811 19.25 15.5938C19.25 14.5064 18.3686 13.625 17.2812 13.625C16.1939 13.625 15.3125 14.5064 15.3125 15.5938C15.3125 16.6811 16.1939 17.5625 17.2812 17.5625Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46875 18.2188C6.55606 18.2188 7.4375 17.3373 7.4375 16.25C7.4375 15.1627 6.55606 14.2812 5.46875 14.2812C4.38144 14.2812 3.5 15.1627 3.5 16.25C3.5 17.3373 4.38144 18.2188 5.46875 18.2188Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5805 9.20391L9.54688 6.89062"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4078 9.6543L13.2422 10.3762"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7273 14.3881L12.9219 12.2061"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.90703 12.3047L6.9375 14.9461"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ManageCredentails = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0498 14.2812V12.3125C19.0498 11.6163 18.7732 10.9486 18.281 10.4563C17.7887 9.96406 17.121 9.6875 16.4248 9.6875C15.7286 9.6875 15.0609 9.96406 14.5686 10.4563C14.0764 10.9486 13.7998 11.6163 13.7998 12.3125V14.2812C13.4518 14.2816 13.1182 14.42 12.8721 14.6661C12.626 14.9121 12.4877 15.2458 12.4873 15.5938V18.875C12.4877 19.223 12.626 19.5566 12.8721 19.8027C13.1182 20.0488 13.4518 20.1872 13.7998 20.1875H19.0498C19.3978 20.1872 19.7314 20.0488 19.9775 19.8027C20.2236 19.5566 20.362 19.223 20.3623 18.875V15.5938C20.362 15.2458 20.2236 14.9121 19.9775 14.6661C19.7314 14.42 19.3978 14.2816 19.0498 14.2812ZM15.1123 12.3125C15.1123 11.9644 15.2506 11.6306 15.4967 11.3844C15.7429 11.1383 16.0767 11 16.4248 11C16.7729 11 17.1067 11.1383 17.3529 11.3844C17.599 11.6306 17.7373 11.9644 17.7373 12.3125V14.2812H15.1123V12.3125ZM13.7998 18.875V15.5938H19.0498V18.875H13.7998Z"
        fill="currentColor"
      />
      <path
        d="M16.096 6.46203L11.6388 2.00478C11.5157 1.8817 11.3488 1.81254 11.1748 1.8125H4.6123C4.26453 1.81354 3.93129 1.95215 3.68537 2.19807C3.43946 2.44399 3.30084 2.77722 3.2998 3.125V18.875C3.30084 19.2228 3.43946 19.556 3.68537 19.8019C3.93129 20.0478 4.26453 20.1865 4.6123 20.1875H9.8623V18.875H4.6123V3.125H9.8623V7.0625C9.86265 7.41049 10.001 7.74413 10.2471 7.99019C10.4932 8.23626 10.8268 8.37465 11.1748 8.375H15.3039C15.5255 8.37481 15.742 8.30897 15.9261 8.18579C16.1103 8.06261 16.2538 7.88763 16.3386 7.68293C16.4233 7.47824 16.4455 7.25302 16.4024 7.03572C16.3592 6.81842 16.2526 6.61878 16.096 6.46203ZM11.1748 7.0625V3.39669L14.84 7.0625H11.1748Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const VerificationIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.35083 17.0293C4.59614 16.2746 5.09653 14.6914 4.71099 13.7645C4.32544 12.8375 2.84888 12.0254 2.84888 11C2.84888 9.97461 4.30903 9.19531 4.71099 8.23555C5.11294 7.27578 4.59614 5.72539 5.35083 4.9707C6.10552 4.21602 7.68872 4.71641 8.61567 4.33086C9.54263 3.94531 10.3547 2.46875 11.3801 2.46875C12.4055 2.46875 13.1848 3.92891 14.1446 4.33086C15.1043 4.73281 16.6547 4.21602 17.4094 4.9707C18.1641 5.72539 17.6637 7.30859 18.0493 8.23555C18.4348 9.1625 19.9114 9.97461 19.9114 11C19.9114 12.0254 18.4512 12.8047 18.0493 13.7645C17.6473 14.7242 18.1641 16.2746 17.4094 17.0293C16.6547 17.784 15.0715 17.2836 14.1446 17.6691C13.2176 18.0547 12.4055 19.5312 11.3801 19.5312C10.3547 19.5312 9.57544 18.0711 8.61567 17.6691C7.65591 17.2672 6.10552 17.784 5.35083 17.0293Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9895 9.03125L10.1743 13.625L7.77075 11.3281"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AnalyticsAndReport = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75513 11H14.0051"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75513 13.625H14.0051"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.47388 3.78125H17.2864C17.4604 3.78125 17.6273 3.85039 17.7504 3.97346C17.8735 4.09653 17.9426 4.26345 17.9426 4.4375V16.9062C17.9426 17.4284 17.7352 17.9292 17.366 18.2984C16.9968 18.6676 16.496 18.875 15.9739 18.875H6.78638C6.26423 18.875 5.76347 18.6676 5.39426 18.2984C5.02505 17.9292 4.81763 17.4284 4.81763 16.9062V4.4375C4.81763 4.26345 4.88677 4.09653 5.00984 3.97346C5.13291 3.85039 5.29983 3.78125 5.47388 3.78125V3.78125Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44263 2.46875V5.09375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3801 2.46875V5.09375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3176 2.46875V5.09375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SettingsIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.927 14.8801V7.1199C18.9264 7.00307 18.895 6.88847 18.8359 6.78765C18.7769 6.68684 18.6923 6.60338 18.5907 6.54568L11.7 2.6492C11.6028 2.59304 11.4924 2.56348 11.3801 2.56348C11.2678 2.56348 11.1575 2.59304 11.0602 2.6492L4.16958 6.54568C4.06798 6.60338 3.9834 6.68684 3.92435 6.78765C3.8653 6.88847 3.83388 7.00307 3.83325 7.1199V14.8801C3.83388 14.9969 3.8653 15.1115 3.92435 15.2123C3.9834 15.3131 4.06798 15.3966 4.16958 15.4543L11.0602 19.3508C11.1575 19.4069 11.2678 19.4365 11.3801 19.4365C11.4924 19.4365 11.6028 19.4069 11.7 19.3508L18.5907 15.4543C18.6923 15.3966 18.7769 15.3131 18.8359 15.2123C18.895 15.1115 18.9264 14.9969 18.927 14.8801V14.8801Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3801 13.9531C13.0111 13.9531 14.3333 12.631 14.3333 11C14.3333 9.36903 13.0111 8.04688 11.3801 8.04688C9.74916 8.04688 8.427 9.36903 8.427 11C8.427 12.631 9.74916 13.9531 11.3801 13.9531Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ActivityIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.09888 5.75H18.5989"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09888 11H18.5989"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09888 16.25H18.5989"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.41138 5.75C5.41138 6.25914 4.99864 6.67188 4.4895 6.67188C3.98036 6.67188 3.56763 6.25914 3.56763 5.75C3.56763 5.24086 3.98036 4.82812 4.4895 4.82812C4.99864 4.82812 5.41138 5.24086 5.41138 5.75Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.125"
        strokeLinecap="round"
      />
      <path
        d="M5.41138 11C5.41138 11.5091 4.99864 11.9219 4.4895 11.9219C3.98036 11.9219 3.56763 11.5091 3.56763 11C3.56763 10.4909 3.98036 10.0781 4.4895 10.0781C4.99864 10.0781 5.41138 10.4909 5.41138 11Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.125"
        strokeLinecap="round"
      />
      <path
        d="M5.41138 16.25C5.41138 16.7591 4.99864 17.1719 4.4895 17.1719C3.98036 17.1719 3.56763 16.7591 3.56763 16.25C3.56763 15.7409 3.98036 15.3281 4.4895 15.3281C4.99864 15.3281 5.41138 15.7409 5.41138 16.25Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.125"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const MenuIcon3Dot = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8 18.2998C10.8 17.902 10.9581 17.5204 11.2394 17.2391C11.5207 16.9578 11.9022 16.7998 12.3 16.7998C12.6979 16.7998 13.0794 16.9578 13.3607 17.2391C13.642 17.5204 13.8 17.902 13.8 18.2998C13.8 18.6976 13.642 19.0792 13.3607 19.3605C13.0794 19.6418 12.6979 19.7998 12.3 19.7998C11.9022 19.7998 11.5207 19.6418 11.2394 19.3605C10.9581 19.0792 10.8 18.6976 10.8 18.2998ZM10.8 12.2998C10.8 11.902 10.9581 11.5204 11.2394 11.2391C11.5207 10.9578 11.9022 10.7998 12.3 10.7998C12.6979 10.7998 13.0794 10.9578 13.3607 11.2391C13.642 11.5204 13.8 11.902 13.8 12.2998C13.8 12.6976 13.642 13.0792 13.3607 13.3605C13.0794 13.6418 12.6979 13.7998 12.3 13.7998C11.9022 13.7998 11.5207 13.6418 11.2394 13.3605C10.9581 13.0792 10.8 12.6976 10.8 12.2998ZM10.8 6.2998C10.8 5.90198 10.9581 5.52045 11.2394 5.23914C11.5207 4.95784 11.9022 4.7998 12.3 4.7998C12.6979 4.7998 13.0794 4.95784 13.3607 5.23914C13.642 5.52045 13.8 5.90198 13.8 6.2998C13.8 6.69763 13.642 7.07916 13.3607 7.36047C13.0794 7.64177 12.6979 7.7998 12.3 7.7998C11.9022 7.7998 11.5207 7.64177 11.2394 7.36047C10.9581 7.07916 10.8 6.69763 10.8 6.2998Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SendRequestIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4294 2.8046L1.86691 6.90616C1.74295 6.94006 1.63244 7.01134 1.55046 7.1103C1.46847 7.20926 1.41898 7.33109 1.40873 7.4592C1.39848 7.5873 1.42797 7.71545 1.49318 7.82619C1.5584 7.93693 1.65616 8.02487 1.77316 8.07804L8.46066 11.2421C8.59166 11.3028 8.69687 11.408 8.75754 11.539L11.9216 18.2265C11.9748 18.3435 12.0627 18.4412 12.1734 18.5065C12.2842 18.5717 12.4123 18.6012 12.5404 18.5909C12.6685 18.5807 12.7904 18.5312 12.8893 18.4492C12.9883 18.3672 13.0596 18.2567 13.0935 18.1327L17.195 3.57023C17.2261 3.46396 17.228 3.35129 17.2006 3.24402C17.1732 3.13676 17.1174 3.03885 17.0391 2.96056C16.9608 2.88226 16.8629 2.82648 16.7556 2.79904C16.6484 2.7716 16.5357 2.77352 16.4294 2.8046V2.8046Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66406 11.3362L12.1953 7.80493"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className="hover:text-light-primary-hover group-disabled:text-dark-primary-500"
    >
      <path
        d="M4.42188 4.18016V2.25516C4.42199 1.94438 4.54552 1.64636 4.76532 1.42664C4.98511 1.20693 5.28317 1.0835 5.59396 1.0835H15.7498C16.0606 1.0835 16.3588 1.20698 16.5786 1.42679C16.7984 1.6466 16.9219 1.94472 16.9219 2.25558V12.4118C16.9218 12.7226 16.7982 13.0206 16.5784 13.2403C16.3586 13.4601 16.0606 13.5835 15.7498 13.5835H13.804"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4143 4.41699H2.25719C1.94648 4.41721 1.64857 4.5408 1.42894 4.76058C1.20931 4.98037 1.08594 5.27836 1.08594 5.58908V15.7449C1.08594 16.0558 1.20942 16.3539 1.42923 16.5737C1.64904 16.7935 1.94717 16.917 2.25802 16.917H12.4143C12.7251 16.9169 13.0231 16.7933 13.2428 16.5735C13.4625 16.3538 13.5859 16.0557 13.5859 15.7449V5.58949C13.586 5.43554 13.5557 5.28308 13.4968 5.14083C13.438 4.99858 13.3516 4.86932 13.2428 4.76043C13.1339 4.65155 13.0047 4.56518 12.8625 4.50625C12.7203 4.44732 12.5682 4.41699 12.4143 4.41699Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CopySmallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className="hover:text-light-primary-hover"
    >
      <path
        d="M3.79688 3.62616V2.27866C3.79695 2.06111 3.88343 1.8525 4.03728 1.6987C4.19114 1.5449 4.39978 1.4585 4.61733 1.4585H11.7264C11.944 1.4585 12.1527 1.54494 12.3066 1.6988C12.4604 1.85267 12.5469 2.06136 12.5469 2.27895V9.38833C12.5468 9.60588 12.4603 9.81449 12.3065 9.96829C12.1526 10.1221 11.944 10.2085 11.7264 10.2085H10.3643"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.39077 3.79199H2.28081C2.06331 3.79215 1.85478 3.87866 1.70104 4.03251C1.5473 4.18635 1.46094 4.39495 1.46094 4.61245V11.7215C1.46094 11.9391 1.54738 12.1478 1.70124 12.3017C1.85511 12.4556 2.0638 12.542 2.2814 12.542H9.39077C9.60832 12.5419 9.81693 12.4554 9.97073 12.3016C10.1245 12.1477 10.2109 11.9391 10.2109 11.7215V4.61274C10.211 4.50497 10.1898 4.39825 10.1486 4.29868C10.1074 4.1991 10.0469 4.10862 9.97073 4.0324C9.89454 3.95618 9.80408 3.89572 9.70452 3.85447C9.60496 3.81322 9.49854 3.79199 9.39077 3.79199Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33268 3.33334H16.666C17.5827 3.33334 18.3327 4.08334 18.3327 5.00001V15C18.3327 15.9167 17.5827 16.6667 16.666 16.6667H3.33268C2.41602 16.6667 1.66602 15.9167 1.66602 15V5.00001C1.66602 4.08334 2.41602 3.33334 3.33268 3.33334Z"
        stroke="#A4A4A8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 5L9.99935 10.8333L1.66602 5"
        stroke="#A4A4A8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PasswordIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 3.125L16.25 16.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1012 12.3127C11.5277 12.838 10.7774 13.1281 9.99967 13.1252C9.36894 13.1251 8.75299 12.9342 8.23279 12.5775C7.7126 12.2208 7.31252 11.7151 7.08513 11.1267C6.85775 10.5384 6.81372 9.89506 6.95882 9.28124C7.10392 8.66743 7.43136 8.11189 7.8981 7.68765"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.78125 5.35922C2.59375 6.9686 1.25 9.99985 1.25 9.99985C1.25 9.99985 3.75 15.6248 10 15.6248C11.4645 15.6368 12.9108 15.2993 14.2188 14.6405"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2969 13.211C18 11.6875 18.75 10 18.75 10C18.75 10 16.25 4.37502 10 4.37502C9.45817 4.37395 8.91721 4.41838 8.38281 4.50783"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5859 6.92969C11.2505 7.05561 11.8561 7.39427 12.3113 7.89457C12.7665 8.39487 13.0466 9.02965 13.1094 9.70313"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShowPasswordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <mask id="path-1-inside-1_35_4325" fill="white">
        <path d="M10.3752 5.91671C9.56756 5.91671 8.77809 6.15619 8.10658 6.60487C7.43508 7.05356 6.91171 7.69129 6.60265 8.43742C6.2936 9.18355 6.21273 10.0046 6.37029 10.7967C6.52785 11.5887 6.91675 12.3163 7.48781 12.8874C8.05887 13.4585 8.78645 13.8474 9.57854 14.0049C10.3706 14.1625 11.1917 14.0816 11.9378 13.7725C12.6839 13.4635 13.3216 12.9401 13.7703 12.2686C14.219 11.5971 14.4585 10.8076 14.4585 10C14.4585 8.91707 14.0283 7.87846 13.2625 7.11269C12.4967 6.34691 11.4581 5.91671 10.3752 5.91671ZM10.3752 12.5834C9.86423 12.5834 9.36477 12.4319 8.93994 12.148C8.51511 11.8641 8.184 11.4607 7.98847 10.9886C7.79295 10.5166 7.74179 9.99717 7.84147 9.49606C7.94115 8.99494 8.18718 8.53463 8.54847 8.17335C8.90976 7.81206 9.37006 7.56602 9.87118 7.46634C10.3723 7.36667 10.8917 7.41782 11.3638 7.61335C11.8358 7.80888 12.2393 8.13999 12.5231 8.56482C12.807 8.98964 12.9585 9.48911 12.9585 10C12.9585 10.6852 12.6863 11.3423 12.2019 11.8267C11.7174 12.3112 11.0603 12.5834 10.3752 12.5834ZM19.2835 8.93337C18.957 8.26137 18.5299 7.64314 18.0168 7.10004C17.0506 6.07346 15.925 5.20957 14.6835 4.54171C13.3682 3.79178 11.8886 3.37682 10.3752 3.33337C8.07297 3.45391 5.87539 4.33294 4.12516 5.83337C3.35802 6.43732 2.67182 7.13752 2.0835 7.91671C1.84623 8.24415 1.63979 8.59286 1.46683 8.95837C1.30944 9.28394 1.22147 9.63867 1.2085 10C1.21798 10.3699 1.30604 10.7335 1.46683 11.0667C1.79331 11.7387 2.22045 12.3569 2.7335 12.9C3.69971 13.9266 4.8253 14.7905 6.06683 15.4584C7.38215 16.2083 8.8617 16.6233 10.3752 16.6667C12.6774 16.5462 14.8749 15.6671 16.6252 14.1667C17.4054 13.5732 18.1056 12.8814 18.7085 12.1084C18.9458 11.7809 19.1522 11.4322 19.3252 11.0667C19.4716 10.7303 19.5454 10.3669 19.5418 10C19.5323 9.63019 19.4443 9.26658 19.2835 8.93337ZM17.7585 10.3917C17.5032 10.8982 17.1747 11.3643 16.7835 11.775C15.9566 12.6599 14.9947 13.4081 13.9335 13.9917C12.8481 14.6147 11.626 14.961 10.3752 15C8.45558 14.8841 6.62655 14.1437 5.16683 12.8917C4.51647 12.3787 3.93402 11.7851 3.4335 11.125C3.26318 10.8953 3.11528 10.6497 2.99183 10.3917C2.9324 10.2682 2.89302 10.136 2.87516 10C2.89302 9.86412 2.9324 9.73191 2.99183 9.60837C3.24713 9.10188 3.57566 8.63577 3.96683 8.22504C4.79372 7.34018 5.75565 6.59201 6.81683 6.00837C7.90222 5.38534 9.12428 5.03904 10.3752 5.00004C12.2947 5.11599 14.1238 5.85638 15.5835 7.10837C16.2339 7.62138 16.8163 8.21503 17.3168 8.87504C17.4871 9.10481 17.635 9.35038 17.7585 9.60837C17.8179 9.73191 17.8573 9.86412 17.8752 10C17.8573 10.136 17.8179 10.2682 17.7585 10.3917Z" />
      </mask>
      <path
        d="M10.3752 5.91671C9.56756 5.91671 8.77809 6.15619 8.10658 6.60487C7.43508 7.05356 6.91171 7.69129 6.60265 8.43742C6.2936 9.18355 6.21273 10.0046 6.37029 10.7967C6.52785 11.5887 6.91675 12.3163 7.48781 12.8874C8.05887 13.4585 8.78645 13.8474 9.57854 14.0049C10.3706 14.1625 11.1917 14.0816 11.9378 13.7725C12.6839 13.4635 13.3216 12.9401 13.7703 12.2686C14.219 11.5971 14.4585 10.8076 14.4585 10C14.4585 8.91707 14.0283 7.87846 13.2625 7.11269C12.4967 6.34691 11.4581 5.91671 10.3752 5.91671ZM10.3752 12.5834C9.86423 12.5834 9.36477 12.4319 8.93994 12.148C8.51511 11.8641 8.184 11.4607 7.98847 10.9886C7.79295 10.5166 7.74179 9.99717 7.84147 9.49606C7.94115 8.99494 8.18718 8.53463 8.54847 8.17335C8.90976 7.81206 9.37006 7.56602 9.87118 7.46634C10.3723 7.36667 10.8917 7.41782 11.3638 7.61335C11.8358 7.80888 12.2393 8.13999 12.5231 8.56482C12.807 8.98964 12.9585 9.48911 12.9585 10C12.9585 10.6852 12.6863 11.3423 12.2019 11.8267C11.7174 12.3112 11.0603 12.5834 10.3752 12.5834ZM19.2835 8.93337C18.957 8.26137 18.5299 7.64314 18.0168 7.10004C17.0506 6.07346 15.925 5.20957 14.6835 4.54171C13.3682 3.79178 11.8886 3.37682 10.3752 3.33337C8.07297 3.45391 5.87539 4.33294 4.12516 5.83337C3.35802 6.43732 2.67182 7.13752 2.0835 7.91671C1.84623 8.24415 1.63979 8.59286 1.46683 8.95837C1.30944 9.28394 1.22147 9.63867 1.2085 10C1.21798 10.3699 1.30604 10.7335 1.46683 11.0667C1.79331 11.7387 2.22045 12.3569 2.7335 12.9C3.69971 13.9266 4.8253 14.7905 6.06683 15.4584C7.38215 16.2083 8.8617 16.6233 10.3752 16.6667C12.6774 16.5462 14.8749 15.6671 16.6252 14.1667C17.4054 13.5732 18.1056 12.8814 18.7085 12.1084C18.9458 11.7809 19.1522 11.4322 19.3252 11.0667C19.4716 10.7303 19.5454 10.3669 19.5418 10C19.5323 9.63019 19.4443 9.26658 19.2835 8.93337ZM17.7585 10.3917C17.5032 10.8982 17.1747 11.3643 16.7835 11.775C15.9566 12.6599 14.9947 13.4081 13.9335 13.9917C12.8481 14.6147 11.626 14.961 10.3752 15C8.45558 14.8841 6.62655 14.1437 5.16683 12.8917C4.51647 12.3787 3.93402 11.7851 3.4335 11.125C3.26318 10.8953 3.11528 10.6497 2.99183 10.3917C2.9324 10.2682 2.89302 10.136 2.87516 10C2.89302 9.86412 2.9324 9.73191 2.99183 9.60837C3.24713 9.10188 3.57566 8.63577 3.96683 8.22504C4.79372 7.34018 5.75565 6.59201 6.81683 6.00837C7.90222 5.38534 9.12428 5.03904 10.3752 5.00004C12.2947 5.11599 14.1238 5.85638 15.5835 7.10837C16.2339 7.62138 16.8163 8.21503 17.3168 8.87504C17.4871 9.10481 17.635 9.35038 17.7585 9.60837C17.8179 9.73191 17.8573 9.86412 17.8752 10C17.8573 10.136 17.8179 10.2682 17.7585 10.3917Z"
        fill="#666666"
      />
      <path
        d="M10.3752 5.91671V7.41671V5.91671ZM14.4585 10H12.9585H14.4585ZM10.3752 12.5834V14.0834V12.5834ZM12.9585 10H14.4585H12.9585ZM19.2835 8.93337L20.6344 8.28149L20.6327 8.27789L19.2835 8.93337ZM18.0168 7.10004L16.9245 8.1281L16.9264 8.1301L18.0168 7.10004ZM14.6835 4.54171L13.9405 5.84479L13.9566 5.85395L13.9729 5.8627L14.6835 4.54171ZM10.3752 3.33337L10.4182 1.83399L10.3574 1.83225L10.2967 1.83543L10.3752 3.33337ZM4.12516 5.83337L5.05302 7.01196L5.07765 6.99258L5.10144 6.97218L4.12516 5.83337ZM2.0835 7.91671L0.886404 7.01284L0.877514 7.02462L0.868857 7.03656L2.0835 7.91671ZM1.46683 8.95837L2.81735 9.61126L2.82269 9.59997L1.46683 8.95837ZM1.2085 10L-0.290538 9.94622L-0.292194 9.99236L-0.291011 10.0385L1.2085 10ZM1.46683 11.0667L0.11588 11.7186L0.11763 11.7222L1.46683 11.0667ZM2.7335 12.9L3.82579 11.872L3.8239 11.87L2.7335 12.9ZM6.06683 15.4584L6.80978 14.1553L6.79372 14.1461L6.77744 14.1374L6.06683 15.4584ZM10.3752 16.6667L10.3321 18.1661L10.3929 18.1678L10.4536 18.1647L10.3752 16.6667ZM16.6252 14.1667L15.7171 12.9728L15.6822 12.9994L15.6489 13.0279L16.6252 14.1667ZM18.7085 12.1084L19.8913 13.0308L19.9076 13.01L19.9231 12.9885L18.7085 12.1084ZM19.3252 11.0667L20.681 11.7083L20.6911 11.687L20.7005 11.6654L19.3252 11.0667ZM19.5418 10L21.0418 9.98535L21.0416 9.97346L21.0413 9.96158L19.5418 10ZM17.7585 10.3917L19.0979 11.0669L19.1042 11.0545L19.1102 11.0419L17.7585 10.3917ZM16.7835 11.775L15.6973 10.7406L15.6924 10.7457L15.6875 10.7509L16.7835 11.775ZM13.9335 13.9917L13.2106 12.6774L13.1986 12.684L13.1867 12.6908L13.9335 13.9917ZM10.3752 15L10.2847 16.4973L10.3533 16.5015L10.4219 16.4993L10.3752 15ZM5.16683 12.8917L6.14338 11.7531L6.11999 11.7331L6.09581 11.714L5.16683 12.8917ZM3.4335 11.125L2.22846 12.0183L2.23335 12.0249L2.23831 12.0314L3.4335 11.125ZM2.99183 10.3917L4.34491 9.74427L4.34356 9.74147L2.99183 10.3917ZM2.87516 10L1.38794 9.80464L1.36227 10L1.38794 10.1954L2.87516 10ZM2.99183 9.60837L1.65237 8.9332L1.64612 8.94561L1.6401 8.95813L2.99183 9.60837ZM3.96683 8.22504L5.05304 9.25952L5.05794 9.25438L5.06278 9.24919L3.96683 8.22504ZM6.81683 6.00837L7.53969 7.32271L7.5517 7.3161L7.56358 7.30928L6.81683 6.00837ZM10.3752 5.00004L10.4656 3.50277L10.3971 3.49863L10.3284 3.50077L10.3752 5.00004ZM15.5835 7.10837L14.6069 8.24695L14.6303 8.267L14.6545 8.28608L15.5835 7.10837ZM17.3168 8.87504L18.5219 7.98179L18.517 7.9752L18.512 7.96866L17.3168 8.87504ZM17.7585 9.60837L16.4054 10.2558L16.4068 10.2586L17.7585 9.60837ZM17.8752 10L19.3624 10.1954L19.3881 10L19.3624 9.80464L17.8752 10ZM10.3752 4.41671C9.27088 4.41671 8.1914 4.74416 7.27323 5.35767L8.93994 7.85208C9.36477 7.56822 9.86423 7.41671 10.3752 7.41671V4.41671ZM7.27323 5.35767C6.35505 5.97117 5.63942 6.84317 5.21684 7.86339L7.98847 9.01144C8.184 8.5394 8.51511 8.13594 8.93994 7.85208L7.27323 5.35767ZM5.21684 7.86339C4.79425 8.88361 4.68368 10.0062 4.89911 11.0893L7.84147 10.504C7.74179 10.0029 7.79295 9.48348 7.98847 9.01144L5.21684 7.86339ZM4.89911 11.0893C5.11455 12.1724 5.64631 13.1672 6.42715 13.9481L8.54847 11.8267C8.18718 11.4654 7.94115 11.0051 7.84147 10.504L4.89911 11.0893ZM6.42715 13.9481C7.20799 14.7289 8.20285 15.2607 9.28591 15.4761L9.87118 12.5337C9.37006 12.4341 8.90976 12.188 8.54847 11.8267L6.42715 13.9481ZM9.28591 15.4761C10.369 15.6915 11.4916 15.581 12.5118 15.1584L11.3638 12.3867C10.8917 12.5823 10.3723 12.6334 9.87118 12.5337L9.28591 15.4761ZM12.5118 15.1584C13.532 14.7358 14.404 14.0201 15.0175 13.102L12.5231 11.4353C12.2393 11.8601 11.8358 12.1912 11.3638 12.3867L12.5118 15.1584ZM15.0175 13.102C15.631 12.1838 15.9585 11.1043 15.9585 10H12.9585C12.9585 10.511 12.807 11.0104 12.5231 11.4353L15.0175 13.102ZM15.9585 10C15.9585 8.51925 15.3703 7.09911 14.3232 6.05203L12.2019 8.17335C12.6863 8.65782 12.9585 9.3149 12.9585 10H15.9585ZM14.3232 6.05203C13.2761 5.00495 11.856 4.41671 10.3752 4.41671V7.41671C11.0603 7.41671 11.7174 7.68888 12.2019 8.17335L14.3232 6.05203ZM10.3752 11.0834C10.1609 11.0834 9.95145 11.0198 9.77329 10.9008L8.10658 13.3952C8.77808 13.8439 9.56755 14.0834 10.3752 14.0834V11.0834ZM9.77329 10.9008C9.59514 10.7818 9.45629 10.6126 9.37429 10.4146L6.60265 11.5627C6.91171 12.3088 7.43508 12.9465 8.10658 13.3952L9.77329 10.9008ZM9.37429 10.4146C9.2923 10.2167 9.27084 9.99884 9.31264 9.78869L6.37029 9.20342C6.21273 9.99551 6.2936 10.8165 6.60265 11.5627L9.37429 10.4146ZM9.31264 9.78869C9.35445 9.57855 9.45762 9.38552 9.60913 9.23401L7.48781 7.11269C6.91675 7.68375 6.52785 8.41133 6.37029 9.20342L9.31264 9.78869ZM9.60913 9.23401C9.76064 9.0825 9.95367 8.97932 10.1638 8.93752L9.57854 5.99517C8.78645 6.15272 8.05887 6.54162 7.48781 7.11269L9.60913 9.23401ZM10.1638 8.93752C10.374 8.89572 10.5918 8.91718 10.7897 8.99917L11.9378 6.22753C11.1917 5.91847 10.3706 5.83761 9.57854 5.99517L10.1638 8.93752ZM10.7897 8.99917C10.9877 9.08117 11.1569 9.22002 11.2759 9.39817L13.7703 7.73146C13.3216 7.05996 12.6839 6.53659 11.9378 6.22753L10.7897 8.99917ZM11.2759 9.39817C11.395 9.57633 11.4585 9.78578 11.4585 10H14.4585C14.4585 9.19243 14.219 8.40296 13.7703 7.73146L11.2759 9.39817ZM11.4585 10C11.4585 10.2874 11.3444 10.5629 11.1412 10.7661L13.2625 12.8874C14.0283 12.1216 14.4585 11.083 14.4585 10H11.4585ZM11.1412 10.7661C10.938 10.9692 10.6625 11.0834 10.3752 11.0834V14.0834C11.4581 14.0834 12.4967 13.6532 13.2625 12.8874L11.1412 10.7661ZM20.6327 8.27789C20.2395 7.46859 19.7251 6.72404 19.1072 6.06998L16.9264 8.1301C17.3347 8.56224 17.6745 9.05416 17.9343 9.58886L20.6327 8.27789ZM19.1091 6.07198C18.0323 4.92785 16.7778 3.96505 15.3941 3.22071L13.9729 5.8627C15.0723 6.45409 16.069 7.21906 16.9245 8.1281L19.1091 6.07198ZM15.4264 3.23862C13.8974 2.36687 12.1775 1.88449 10.4182 1.83399L10.3321 4.83276C11.5997 4.86914 12.8389 5.21669 13.9405 5.84479L15.4264 3.23862ZM10.2967 1.83543C7.66382 1.97328 5.15055 2.97859 3.14889 4.69456L5.10144 6.97218C6.60024 5.6873 8.48212 4.93454 10.4536 4.83132L10.2967 1.83543ZM3.1973 4.65478C2.32899 5.33837 1.55231 6.1309 0.886404 7.01284L3.28059 8.82057C3.79133 8.14413 4.38704 7.53627 5.05302 7.01196L3.1973 4.65478ZM0.868857 7.03656C0.577251 7.43899 0.323539 7.86756 0.110969 8.31678L2.82269 9.59997C2.95604 9.31816 3.1152 9.04931 3.29814 8.79685L0.868857 7.03656ZM0.116357 8.30551C-0.131539 8.8183 -0.270103 9.37703 -0.290538 9.94622L2.70753 10.0539C2.71304 9.9003 2.75042 9.74957 2.8173 9.61123L0.116357 8.30551ZM-0.291011 10.0385C-0.276068 10.6211 -0.137367 11.1938 0.115885 11.7186L2.81777 10.4148C2.74945 10.2732 2.71203 10.1187 2.708 9.96158L-0.291011 10.0385ZM0.11763 11.7222C0.510814 12.5315 1.02523 13.276 1.64309 13.9301L3.8239 11.87C3.41567 11.4378 3.0758 10.9459 2.81603 10.4112L0.11763 11.7222ZM1.64121 13.9281C2.71806 15.0722 3.97253 16.035 5.35622 16.7794L6.77744 14.1374C5.67807 13.546 4.68136 12.781 3.82579 11.872L1.64121 13.9281ZM5.32388 16.7615C6.85288 17.6332 8.57279 18.1156 10.3321 18.1661L10.4182 15.1673C9.15061 15.1309 7.91142 14.7834 6.80978 14.1553L5.32388 16.7615ZM10.4536 18.1647C13.0865 18.0268 15.5998 17.0215 17.6014 15.3055L15.6489 13.0279C14.1501 14.3128 12.2682 15.0655 10.2967 15.1688L10.4536 18.1647ZM17.5333 15.3606C18.4164 14.6889 19.209 13.9058 19.8913 13.0308L17.5257 11.1859C17.0023 11.857 16.3944 12.4576 15.7171 12.9728L17.5333 15.3606ZM19.9231 12.9885C20.2147 12.5861 20.4685 12.1575 20.681 11.7083L17.9693 10.4251C17.836 10.7069 17.6768 10.9758 17.4939 11.2282L19.9231 12.9885ZM20.7005 11.6654C20.9311 11.1356 21.0474 10.5631 21.0418 9.98535L18.0419 10.0147C18.0434 10.1706 18.0121 10.3251 17.9498 10.468L20.7005 11.6654ZM21.0413 9.96158C21.0264 9.37904 20.8877 8.80633 20.6344 8.28149L17.9326 9.58526C18.0009 9.72684 18.0383 9.88134 18.0423 10.0385L21.0413 9.96158ZM16.419 9.71653C16.23 10.0915 15.9869 10.4365 15.6973 10.7406L17.8697 12.8095C18.3625 12.2921 18.7763 11.7049 19.0979 11.0669L16.419 9.71653ZM15.6875 10.7509C14.9689 11.5199 14.1329 12.1701 13.2106 12.6774L14.6564 15.306C15.8565 14.646 16.9443 13.7999 17.8794 12.7992L15.6875 10.7509ZM13.1867 12.6908C12.3149 13.1913 11.3332 13.4694 10.3284 13.5008L10.4219 16.4993C11.9189 16.4526 13.3813 16.0382 14.6802 15.2926L13.1867 12.6908ZM10.4656 13.5028C8.8726 13.4065 7.35475 12.7921 6.14338 11.7531L4.19028 14.0303C5.89834 15.4953 8.03855 16.3616 10.2847 16.4973L10.4656 13.5028ZM6.09581 11.714C5.54533 11.2798 5.05234 10.7773 4.62869 10.2187L2.23831 12.0314C2.8157 12.7928 3.48761 13.4776 4.23785 14.0694L6.09581 11.714ZM4.63853 10.2318C4.5253 10.079 4.42698 9.91579 4.34491 9.74427L1.63875 11.0391C1.80358 11.3836 2.00105 11.7115 2.22846 12.0183L4.63853 10.2318ZM4.34356 9.74147C4.35315 9.76139 4.3595 9.78271 4.36238 9.80464L1.38794 10.1954C1.42654 10.4892 1.51166 10.775 1.6401 11.0419L4.34356 9.74147ZM4.36238 10.1954C4.3595 10.2174 4.35315 10.2387 4.34356 10.2586L1.6401 8.95813C1.51166 9.22513 1.42654 9.51088 1.38794 9.80464L4.36238 10.1954ZM4.33128 10.2835C4.52028 9.90861 4.76347 9.56357 5.05304 9.25952L2.88062 7.19056C2.38785 7.70797 1.97399 8.29516 1.65237 8.9332L4.33128 10.2835ZM5.06278 9.24919C5.78142 8.48017 6.61744 7.82993 7.53969 7.32271L6.09397 4.69404C4.89387 5.35408 3.80601 6.20019 2.87087 7.20089L5.06278 9.24919ZM7.56358 7.30928C8.43545 6.80882 9.4171 6.53064 10.4219 6.49931L10.3284 3.50077C8.83145 3.54744 7.36899 3.96187 6.07008 4.70746L7.56358 7.30928ZM10.2847 6.49731C11.8777 6.59354 13.3956 7.20796 14.6069 8.24695L16.56 5.9698C14.852 4.50481 12.7118 3.63845 10.4656 3.50277L10.2847 6.49731ZM14.6545 8.28608C15.205 8.7203 15.698 9.22278 16.1216 9.78142L18.512 7.96866C17.9346 7.20728 17.2627 6.52245 16.5125 5.93066L14.6545 8.28608ZM16.1118 9.76829C16.225 9.92104 16.3233 10.0843 16.4054 10.2558L19.1116 8.96094C18.9467 8.61646 18.7493 8.28858 18.5219 7.98179L16.1118 9.76829ZM16.4068 10.2586C16.3972 10.2387 16.3908 10.2174 16.3879 10.1954L19.3624 9.80464C19.3238 9.51088 19.2387 9.22513 19.1102 8.95813L16.4068 10.2586ZM16.3879 9.80464C16.3908 9.78271 16.3972 9.76139 16.4068 9.74147L19.1102 11.0419C19.2387 10.775 19.3238 10.4892 19.3624 10.1954L16.3879 9.80464Z"
        fill="#666666"
        mask="url(#path-1-inside-1_35_4325)"
      />
    </svg>
  );
};

export const ShowEyeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={twMerge(
        "hover:text-light-primary-hover group-disabled:text-dark-primary-500",
        className
      )}
    >
      <mask id="path-1-inside-1_35_4325" fill="white">
        <path d="M10.3752 5.91671C9.56756 5.91671 8.77809 6.15619 8.10658 6.60487C7.43508 7.05356 6.91171 7.69129 6.60265 8.43742C6.2936 9.18355 6.21273 10.0046 6.37029 10.7967C6.52785 11.5887 6.91675 12.3163 7.48781 12.8874C8.05887 13.4585 8.78645 13.8474 9.57854 14.0049C10.3706 14.1625 11.1917 14.0816 11.9378 13.7725C12.6839 13.4635 13.3216 12.9401 13.7703 12.2686C14.219 11.5971 14.4585 10.8076 14.4585 10C14.4585 8.91707 14.0283 7.87846 13.2625 7.11269C12.4967 6.34691 11.4581 5.91671 10.3752 5.91671ZM10.3752 12.5834C9.86423 12.5834 9.36477 12.4319 8.93994 12.148C8.51511 11.8641 8.184 11.4607 7.98847 10.9886C7.79295 10.5166 7.74179 9.99717 7.84147 9.49606C7.94115 8.99494 8.18718 8.53463 8.54847 8.17335C8.90976 7.81206 9.37006 7.56602 9.87118 7.46634C10.3723 7.36667 10.8917 7.41782 11.3638 7.61335C11.8358 7.80888 12.2393 8.13999 12.5231 8.56482C12.807 8.98964 12.9585 9.48911 12.9585 10C12.9585 10.6852 12.6863 11.3423 12.2019 11.8267C11.7174 12.3112 11.0603 12.5834 10.3752 12.5834ZM19.2835 8.93337C18.957 8.26137 18.5299 7.64314 18.0168 7.10004C17.0506 6.07346 15.925 5.20957 14.6835 4.54171C13.3682 3.79178 11.8886 3.37682 10.3752 3.33337C8.07297 3.45391 5.87539 4.33294 4.12516 5.83337C3.35802 6.43732 2.67182 7.13752 2.0835 7.91671C1.84623 8.24415 1.63979 8.59286 1.46683 8.95837C1.30944 9.28394 1.22147 9.63867 1.2085 10C1.21798 10.3699 1.30604 10.7335 1.46683 11.0667C1.79331 11.7387 2.22045 12.3569 2.7335 12.9C3.69971 13.9266 4.8253 14.7905 6.06683 15.4584C7.38215 16.2083 8.8617 16.6233 10.3752 16.6667C12.6774 16.5462 14.8749 15.6671 16.6252 14.1667C17.4054 13.5732 18.1056 12.8814 18.7085 12.1084C18.9458 11.7809 19.1522 11.4322 19.3252 11.0667C19.4716 10.7303 19.5454 10.3669 19.5418 10C19.5323 9.63019 19.4443 9.26658 19.2835 8.93337ZM17.7585 10.3917C17.5032 10.8982 17.1747 11.3643 16.7835 11.775C15.9566 12.6599 14.9947 13.4081 13.9335 13.9917C12.8481 14.6147 11.626 14.961 10.3752 15C8.45558 14.8841 6.62655 14.1437 5.16683 12.8917C4.51647 12.3787 3.93402 11.7851 3.4335 11.125C3.26318 10.8953 3.11528 10.6497 2.99183 10.3917C2.9324 10.2682 2.89302 10.136 2.87516 10C2.89302 9.86412 2.9324 9.73191 2.99183 9.60837C3.24713 9.10188 3.57566 8.63577 3.96683 8.22504C4.79372 7.34018 5.75565 6.59201 6.81683 6.00837C7.90222 5.38534 9.12428 5.03904 10.3752 5.00004C12.2947 5.11599 14.1238 5.85638 15.5835 7.10837C16.2339 7.62138 16.8163 8.21503 17.3168 8.87504C17.4871 9.10481 17.635 9.35038 17.7585 9.60837C17.8179 9.73191 17.8573 9.86412 17.8752 10C17.8573 10.136 17.8179 10.2682 17.7585 10.3917Z" />
      </mask>
      <path
        d="M10.3752 5.91671C9.56756 5.91671 8.77809 6.15619 8.10658 6.60487C7.43508 7.05356 6.91171 7.69129 6.60265 8.43742C6.2936 9.18355 6.21273 10.0046 6.37029 10.7967C6.52785 11.5887 6.91675 12.3163 7.48781 12.8874C8.05887 13.4585 8.78645 13.8474 9.57854 14.0049C10.3706 14.1625 11.1917 14.0816 11.9378 13.7725C12.6839 13.4635 13.3216 12.9401 13.7703 12.2686C14.219 11.5971 14.4585 10.8076 14.4585 10C14.4585 8.91707 14.0283 7.87846 13.2625 7.11269C12.4967 6.34691 11.4581 5.91671 10.3752 5.91671ZM10.3752 12.5834C9.86423 12.5834 9.36477 12.4319 8.93994 12.148C8.51511 11.8641 8.184 11.4607 7.98847 10.9886C7.79295 10.5166 7.74179 9.99717 7.84147 9.49606C7.94115 8.99494 8.18718 8.53463 8.54847 8.17335C8.90976 7.81206 9.37006 7.56602 9.87118 7.46634C10.3723 7.36667 10.8917 7.41782 11.3638 7.61335C11.8358 7.80888 12.2393 8.13999 12.5231 8.56482C12.807 8.98964 12.9585 9.48911 12.9585 10C12.9585 10.6852 12.6863 11.3423 12.2019 11.8267C11.7174 12.3112 11.0603 12.5834 10.3752 12.5834ZM19.2835 8.93337C18.957 8.26137 18.5299 7.64314 18.0168 7.10004C17.0506 6.07346 15.925 5.20957 14.6835 4.54171C13.3682 3.79178 11.8886 3.37682 10.3752 3.33337C8.07297 3.45391 5.87539 4.33294 4.12516 5.83337C3.35802 6.43732 2.67182 7.13752 2.0835 7.91671C1.84623 8.24415 1.63979 8.59286 1.46683 8.95837C1.30944 9.28394 1.22147 9.63867 1.2085 10C1.21798 10.3699 1.30604 10.7335 1.46683 11.0667C1.79331 11.7387 2.22045 12.3569 2.7335 12.9C3.69971 13.9266 4.8253 14.7905 6.06683 15.4584C7.38215 16.2083 8.8617 16.6233 10.3752 16.6667C12.6774 16.5462 14.8749 15.6671 16.6252 14.1667C17.4054 13.5732 18.1056 12.8814 18.7085 12.1084C18.9458 11.7809 19.1522 11.4322 19.3252 11.0667C19.4716 10.7303 19.5454 10.3669 19.5418 10C19.5323 9.63019 19.4443 9.26658 19.2835 8.93337ZM17.7585 10.3917C17.5032 10.8982 17.1747 11.3643 16.7835 11.775C15.9566 12.6599 14.9947 13.4081 13.9335 13.9917C12.8481 14.6147 11.626 14.961 10.3752 15C8.45558 14.8841 6.62655 14.1437 5.16683 12.8917C4.51647 12.3787 3.93402 11.7851 3.4335 11.125C3.26318 10.8953 3.11528 10.6497 2.99183 10.3917C2.9324 10.2682 2.89302 10.136 2.87516 10C2.89302 9.86412 2.9324 9.73191 2.99183 9.60837C3.24713 9.10188 3.57566 8.63577 3.96683 8.22504C4.79372 7.34018 5.75565 6.59201 6.81683 6.00837C7.90222 5.38534 9.12428 5.03904 10.3752 5.00004C12.2947 5.11599 14.1238 5.85638 15.5835 7.10837C16.2339 7.62138 16.8163 8.21503 17.3168 8.87504C17.4871 9.10481 17.635 9.35038 17.7585 9.60837C17.8179 9.73191 17.8573 9.86412 17.8752 10C17.8573 10.136 17.8179 10.2682 17.7585 10.3917Z"
        fill="currentColor"
      />
      <path
        d="M10.3752 5.91671V7.41671V5.91671ZM14.4585 10H12.9585H14.4585ZM10.3752 12.5834V14.0834V12.5834ZM12.9585 10H14.4585H12.9585ZM19.2835 8.93337L20.6344 8.28149L20.6327 8.27789L19.2835 8.93337ZM18.0168 7.10004L16.9245 8.1281L16.9264 8.1301L18.0168 7.10004ZM14.6835 4.54171L13.9405 5.84479L13.9566 5.85395L13.9729 5.8627L14.6835 4.54171ZM10.3752 3.33337L10.4182 1.83399L10.3574 1.83225L10.2967 1.83543L10.3752 3.33337ZM4.12516 5.83337L5.05302 7.01196L5.07765 6.99258L5.10144 6.97218L4.12516 5.83337ZM2.0835 7.91671L0.886404 7.01284L0.877514 7.02462L0.868857 7.03656L2.0835 7.91671ZM1.46683 8.95837L2.81735 9.61126L2.82269 9.59997L1.46683 8.95837ZM1.2085 10L-0.290538 9.94622L-0.292194 9.99236L-0.291011 10.0385L1.2085 10ZM1.46683 11.0667L0.11588 11.7186L0.11763 11.7222L1.46683 11.0667ZM2.7335 12.9L3.82579 11.872L3.8239 11.87L2.7335 12.9ZM6.06683 15.4584L6.80978 14.1553L6.79372 14.1461L6.77744 14.1374L6.06683 15.4584ZM10.3752 16.6667L10.3321 18.1661L10.3929 18.1678L10.4536 18.1647L10.3752 16.6667ZM16.6252 14.1667L15.7171 12.9728L15.6822 12.9994L15.6489 13.0279L16.6252 14.1667ZM18.7085 12.1084L19.8913 13.0308L19.9076 13.01L19.9231 12.9885L18.7085 12.1084ZM19.3252 11.0667L20.681 11.7083L20.6911 11.687L20.7005 11.6654L19.3252 11.0667ZM19.5418 10L21.0418 9.98535L21.0416 9.97346L21.0413 9.96158L19.5418 10ZM17.7585 10.3917L19.0979 11.0669L19.1042 11.0545L19.1102 11.0419L17.7585 10.3917ZM16.7835 11.775L15.6973 10.7406L15.6924 10.7457L15.6875 10.7509L16.7835 11.775ZM13.9335 13.9917L13.2106 12.6774L13.1986 12.684L13.1867 12.6908L13.9335 13.9917ZM10.3752 15L10.2847 16.4973L10.3533 16.5015L10.4219 16.4993L10.3752 15ZM5.16683 12.8917L6.14338 11.7531L6.11999 11.7331L6.09581 11.714L5.16683 12.8917ZM3.4335 11.125L2.22846 12.0183L2.23335 12.0249L2.23831 12.0314L3.4335 11.125ZM2.99183 10.3917L4.34491 9.74427L4.34356 9.74147L2.99183 10.3917ZM2.87516 10L1.38794 9.80464L1.36227 10L1.38794 10.1954L2.87516 10ZM2.99183 9.60837L1.65237 8.9332L1.64612 8.94561L1.6401 8.95813L2.99183 9.60837ZM3.96683 8.22504L5.05304 9.25952L5.05794 9.25438L5.06278 9.24919L3.96683 8.22504ZM6.81683 6.00837L7.53969 7.32271L7.5517 7.3161L7.56358 7.30928L6.81683 6.00837ZM10.3752 5.00004L10.4656 3.50277L10.3971 3.49863L10.3284 3.50077L10.3752 5.00004ZM15.5835 7.10837L14.6069 8.24695L14.6303 8.267L14.6545 8.28608L15.5835 7.10837ZM17.3168 8.87504L18.5219 7.98179L18.517 7.9752L18.512 7.96866L17.3168 8.87504ZM17.7585 9.60837L16.4054 10.2558L16.4068 10.2586L17.7585 9.60837ZM17.8752 10L19.3624 10.1954L19.3881 10L19.3624 9.80464L17.8752 10ZM10.3752 4.41671C9.27088 4.41671 8.1914 4.74416 7.27323 5.35767L8.93994 7.85208C9.36477 7.56822 9.86423 7.41671 10.3752 7.41671V4.41671ZM7.27323 5.35767C6.35505 5.97117 5.63942 6.84317 5.21684 7.86339L7.98847 9.01144C8.184 8.5394 8.51511 8.13594 8.93994 7.85208L7.27323 5.35767ZM5.21684 7.86339C4.79425 8.88361 4.68368 10.0062 4.89911 11.0893L7.84147 10.504C7.74179 10.0029 7.79295 9.48348 7.98847 9.01144L5.21684 7.86339ZM4.89911 11.0893C5.11455 12.1724 5.64631 13.1672 6.42715 13.9481L8.54847 11.8267C8.18718 11.4654 7.94115 11.0051 7.84147 10.504L4.89911 11.0893ZM6.42715 13.9481C7.20799 14.7289 8.20285 15.2607 9.28591 15.4761L9.87118 12.5337C9.37006 12.4341 8.90976 12.188 8.54847 11.8267L6.42715 13.9481ZM9.28591 15.4761C10.369 15.6915 11.4916 15.581 12.5118 15.1584L11.3638 12.3867C10.8917 12.5823 10.3723 12.6334 9.87118 12.5337L9.28591 15.4761ZM12.5118 15.1584C13.532 14.7358 14.404 14.0201 15.0175 13.102L12.5231 11.4353C12.2393 11.8601 11.8358 12.1912 11.3638 12.3867L12.5118 15.1584ZM15.0175 13.102C15.631 12.1838 15.9585 11.1043 15.9585 10H12.9585C12.9585 10.511 12.807 11.0104 12.5231 11.4353L15.0175 13.102ZM15.9585 10C15.9585 8.51925 15.3703 7.09911 14.3232 6.05203L12.2019 8.17335C12.6863 8.65782 12.9585 9.3149 12.9585 10H15.9585ZM14.3232 6.05203C13.2761 5.00495 11.856 4.41671 10.3752 4.41671V7.41671C11.0603 7.41671 11.7174 7.68888 12.2019 8.17335L14.3232 6.05203ZM10.3752 11.0834C10.1609 11.0834 9.95145 11.0198 9.77329 10.9008L8.10658 13.3952C8.77808 13.8439 9.56755 14.0834 10.3752 14.0834V11.0834ZM9.77329 10.9008C9.59514 10.7818 9.45629 10.6126 9.37429 10.4146L6.60265 11.5627C6.91171 12.3088 7.43508 12.9465 8.10658 13.3952L9.77329 10.9008ZM9.37429 10.4146C9.2923 10.2167 9.27084 9.99884 9.31264 9.78869L6.37029 9.20342C6.21273 9.99551 6.2936 10.8165 6.60265 11.5627L9.37429 10.4146ZM9.31264 9.78869C9.35445 9.57855 9.45762 9.38552 9.60913 9.23401L7.48781 7.11269C6.91675 7.68375 6.52785 8.41133 6.37029 9.20342L9.31264 9.78869ZM9.60913 9.23401C9.76064 9.0825 9.95367 8.97932 10.1638 8.93752L9.57854 5.99517C8.78645 6.15272 8.05887 6.54162 7.48781 7.11269L9.60913 9.23401ZM10.1638 8.93752C10.374 8.89572 10.5918 8.91718 10.7897 8.99917L11.9378 6.22753C11.1917 5.91847 10.3706 5.83761 9.57854 5.99517L10.1638 8.93752ZM10.7897 8.99917C10.9877 9.08117 11.1569 9.22002 11.2759 9.39817L13.7703 7.73146C13.3216 7.05996 12.6839 6.53659 11.9378 6.22753L10.7897 8.99917ZM11.2759 9.39817C11.395 9.57633 11.4585 9.78578 11.4585 10H14.4585C14.4585 9.19243 14.219 8.40296 13.7703 7.73146L11.2759 9.39817ZM11.4585 10C11.4585 10.2874 11.3444 10.5629 11.1412 10.7661L13.2625 12.8874C14.0283 12.1216 14.4585 11.083 14.4585 10H11.4585ZM11.1412 10.7661C10.938 10.9692 10.6625 11.0834 10.3752 11.0834V14.0834C11.4581 14.0834 12.4967 13.6532 13.2625 12.8874L11.1412 10.7661ZM20.6327 8.27789C20.2395 7.46859 19.7251 6.72404 19.1072 6.06998L16.9264 8.1301C17.3347 8.56224 17.6745 9.05416 17.9343 9.58886L20.6327 8.27789ZM19.1091 6.07198C18.0323 4.92785 16.7778 3.96505 15.3941 3.22071L13.9729 5.8627C15.0723 6.45409 16.069 7.21906 16.9245 8.1281L19.1091 6.07198ZM15.4264 3.23862C13.8974 2.36687 12.1775 1.88449 10.4182 1.83399L10.3321 4.83276C11.5997 4.86914 12.8389 5.21669 13.9405 5.84479L15.4264 3.23862ZM10.2967 1.83543C7.66382 1.97328 5.15055 2.97859 3.14889 4.69456L5.10144 6.97218C6.60024 5.6873 8.48212 4.93454 10.4536 4.83132L10.2967 1.83543ZM3.1973 4.65478C2.32899 5.33837 1.55231 6.1309 0.886404 7.01284L3.28059 8.82057C3.79133 8.14413 4.38704 7.53627 5.05302 7.01196L3.1973 4.65478ZM0.868857 7.03656C0.577251 7.43899 0.323539 7.86756 0.110969 8.31678L2.82269 9.59997C2.95604 9.31816 3.1152 9.04931 3.29814 8.79685L0.868857 7.03656ZM0.116357 8.30551C-0.131539 8.8183 -0.270103 9.37703 -0.290538 9.94622L2.70753 10.0539C2.71304 9.9003 2.75042 9.74957 2.8173 9.61123L0.116357 8.30551ZM-0.291011 10.0385C-0.276068 10.6211 -0.137367 11.1938 0.115885 11.7186L2.81777 10.4148C2.74945 10.2732 2.71203 10.1187 2.708 9.96158L-0.291011 10.0385ZM0.11763 11.7222C0.510814 12.5315 1.02523 13.276 1.64309 13.9301L3.8239 11.87C3.41567 11.4378 3.0758 10.9459 2.81603 10.4112L0.11763 11.7222ZM1.64121 13.9281C2.71806 15.0722 3.97253 16.035 5.35622 16.7794L6.77744 14.1374C5.67807 13.546 4.68136 12.781 3.82579 11.872L1.64121 13.9281ZM5.32388 16.7615C6.85288 17.6332 8.57279 18.1156 10.3321 18.1661L10.4182 15.1673C9.15061 15.1309 7.91142 14.7834 6.80978 14.1553L5.32388 16.7615ZM10.4536 18.1647C13.0865 18.0268 15.5998 17.0215 17.6014 15.3055L15.6489 13.0279C14.1501 14.3128 12.2682 15.0655 10.2967 15.1688L10.4536 18.1647ZM17.5333 15.3606C18.4164 14.6889 19.209 13.9058 19.8913 13.0308L17.5257 11.1859C17.0023 11.857 16.3944 12.4576 15.7171 12.9728L17.5333 15.3606ZM19.9231 12.9885C20.2147 12.5861 20.4685 12.1575 20.681 11.7083L17.9693 10.4251C17.836 10.7069 17.6768 10.9758 17.4939 11.2282L19.9231 12.9885ZM20.7005 11.6654C20.9311 11.1356 21.0474 10.5631 21.0418 9.98535L18.0419 10.0147C18.0434 10.1706 18.0121 10.3251 17.9498 10.468L20.7005 11.6654ZM21.0413 9.96158C21.0264 9.37904 20.8877 8.80633 20.6344 8.28149L17.9326 9.58526C18.0009 9.72684 18.0383 9.88134 18.0423 10.0385L21.0413 9.96158ZM16.419 9.71653C16.23 10.0915 15.9869 10.4365 15.6973 10.7406L17.8697 12.8095C18.3625 12.2921 18.7763 11.7049 19.0979 11.0669L16.419 9.71653ZM15.6875 10.7509C14.9689 11.5199 14.1329 12.1701 13.2106 12.6774L14.6564 15.306C15.8565 14.646 16.9443 13.7999 17.8794 12.7992L15.6875 10.7509ZM13.1867 12.6908C12.3149 13.1913 11.3332 13.4694 10.3284 13.5008L10.4219 16.4993C11.9189 16.4526 13.3813 16.0382 14.6802 15.2926L13.1867 12.6908ZM10.4656 13.5028C8.8726 13.4065 7.35475 12.7921 6.14338 11.7531L4.19028 14.0303C5.89834 15.4953 8.03855 16.3616 10.2847 16.4973L10.4656 13.5028ZM6.09581 11.714C5.54533 11.2798 5.05234 10.7773 4.62869 10.2187L2.23831 12.0314C2.8157 12.7928 3.48761 13.4776 4.23785 14.0694L6.09581 11.714ZM4.63853 10.2318C4.5253 10.079 4.42698 9.91579 4.34491 9.74427L1.63875 11.0391C1.80358 11.3836 2.00105 11.7115 2.22846 12.0183L4.63853 10.2318ZM4.34356 9.74147C4.35315 9.76139 4.3595 9.78271 4.36238 9.80464L1.38794 10.1954C1.42654 10.4892 1.51166 10.775 1.6401 11.0419L4.34356 9.74147ZM4.36238 10.1954C4.3595 10.2174 4.35315 10.2387 4.34356 10.2586L1.6401 8.95813C1.51166 9.22513 1.42654 9.51088 1.38794 9.80464L4.36238 10.1954ZM4.33128 10.2835C4.52028 9.90861 4.76347 9.56357 5.05304 9.25952L2.88062 7.19056C2.38785 7.70797 1.97399 8.29516 1.65237 8.9332L4.33128 10.2835ZM5.06278 9.24919C5.78142 8.48017 6.61744 7.82993 7.53969 7.32271L6.09397 4.69404C4.89387 5.35408 3.80601 6.20019 2.87087 7.20089L5.06278 9.24919ZM7.56358 7.30928C8.43545 6.80882 9.4171 6.53064 10.4219 6.49931L10.3284 3.50077C8.83145 3.54744 7.36899 3.96187 6.07008 4.70746L7.56358 7.30928ZM10.2847 6.49731C11.8777 6.59354 13.3956 7.20796 14.6069 8.24695L16.56 5.9698C14.852 4.50481 12.7118 3.63845 10.4656 3.50277L10.2847 6.49731ZM14.6545 8.28608C15.205 8.7203 15.698 9.22278 16.1216 9.78142L18.512 7.96866C17.9346 7.20728 17.2627 6.52245 16.5125 5.93066L14.6545 8.28608ZM16.1118 9.76829C16.225 9.92104 16.3233 10.0843 16.4054 10.2558L19.1116 8.96094C18.9467 8.61646 18.7493 8.28858 18.5219 7.98179L16.1118 9.76829ZM16.4068 10.2586C16.3972 10.2387 16.3908 10.2174 16.3879 10.1954L19.3624 9.80464C19.3238 9.51088 19.2387 9.22513 19.1102 8.95813L16.4068 10.2586ZM16.3879 9.80464C16.3908 9.78271 16.3972 9.76139 16.4068 9.74147L19.1102 11.0419C19.2387 10.775 19.3238 10.4892 19.3624 10.1954L16.3879 9.80464Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_35_4325)"
      />
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="25"
      height="25"
      viewBox="0 0 32 32"
    >
      <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z"></path>
    </svg>
  );
};

export const TooltipIcon = () => {
  return (
    <svg
      fill="#ffffff"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="15px"
      height="15px"
      viewBox="-41.7 -41.7 500.38 500.38"
      xmlSpace="preserve"
      stroke="#ffffff"
      strokeWidth={0.0041697900000000005}
    >
      <g
        id="SVGRepo_bgCarrier"
        strokeWidth={0}
        transform="translate(0,0), scale(1)"
      >
        <rect
          x={-41.7}
          y={-41.7}
          width={500.38}
          height={500.38}
          rx={250.19}
          fill="#000000"
          strokeWidth={0}
        />
      </g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth={9.173537999999999}
      />
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z" />
        </g>
      </g>
    </svg>
  );
};

export const TemplateIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 21H5.25C5.05109 21 4.86032 20.921 4.71967 20.7803C4.57902 20.6397 4.5 20.4489 4.5 20.25V6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6H12.75L16.5 9.75V20.25C16.5 20.4489 16.421 20.6397 16.2803 20.7803C16.1397 20.921 15.9489 21 15.75 21Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 6V3.75C7.5 3.55109 7.57902 3.36032 7.71967 3.21967C7.86032 3.07902 8.05109 3 8.25 3H15.75L19.5 6.75V17.25C19.5 17.4489 19.421 17.6397 19.2803 17.7803C19.1397 17.921 18.9489 18 18.75 18H16.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 14.25H12.75"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 17.25H12.75"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RevokedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 12.75L3 8.25L7.5 3.75"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.75H15.75C17.1424 18.75 18.4777 18.1969 19.4623 17.2123C20.4469 16.2277 21 14.8924 21 13.5V13.5C21 12.1076 20.4469 10.7723 19.4623 9.78769C18.4777 8.80312 17.1424 8.25 15.75 8.25H3"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExpiredIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 2.25V5.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 2.25V5.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 8.25H20.25"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 12L9.75 16.5"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 16.5L9.75 12"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GenerateReportIconSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="pointer-events-none"
    >
      <path
        d="M15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5Z"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 2.5V6.875H16.25"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.8125 12.1875L10 14.375L12.1875 12.1875"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.375V14.375"
        stroke="#335CA4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CredentialsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M18.375 13.7812V11.8125C18.375 11.1163 18.0984 10.4486 17.6062 9.95634C17.1139 9.46406 16.4462 9.1875 15.75 9.1875C15.0538 9.1875 14.3861 9.46406 13.8938 9.95634C13.4016 10.4486 13.125 11.1163 13.125 11.8125V13.7812C12.777 13.7816 12.4434 13.92 12.1973 14.1661C11.9512 14.4121 11.8128 14.7458 11.8125 15.0938V18.375C11.8128 18.723 11.9512 19.0566 12.1973 19.3027C12.4434 19.5488 12.777 19.6872 13.125 19.6875H18.375C18.723 19.6872 19.0566 19.5488 19.3027 19.3027C19.5488 19.0566 19.6872 18.723 19.6875 18.375V15.0938C19.6872 14.7458 19.5488 14.4121 19.3027 14.1661C19.0566 13.92 18.723 13.7816 18.375 13.7812ZM14.4375 11.8125C14.4375 11.4644 14.5758 11.1306 14.8219 10.8844C15.0681 10.6383 15.4019 10.5 15.75 10.5C16.0981 10.5 16.4319 10.6383 16.6781 10.8844C16.9242 11.1306 17.0625 11.4644 17.0625 11.8125V13.7812H14.4375V11.8125ZM13.125 18.375V15.0938H18.375V18.375H13.125Z"
        fill="#00338D"
      />
      <path
        d="M15.4212 5.96203L10.964 1.50478C10.8409 1.3817 10.674 1.31254 10.5 1.3125H3.9375C3.58972 1.31354 3.25649 1.45215 3.01057 1.69807C2.76465 1.94399 2.62604 2.27722 2.625 2.625V18.375C2.62604 18.7228 2.76465 19.056 3.01057 19.3019C3.25649 19.5478 3.58972 19.6865 3.9375 19.6875H9.1875V18.375H3.9375V2.625H9.1875V6.5625C9.18785 6.91049 9.32624 7.24413 9.57231 7.49019C9.81837 7.73626 10.152 7.87465 10.5 7.875H14.6291C14.8507 7.87481 15.0672 7.80897 15.2513 7.68579C15.4355 7.56261 15.579 7.38763 15.6638 7.18293C15.7485 6.97824 15.7707 6.75302 15.7275 6.53572C15.6844 6.31842 15.5778 6.11878 15.4212 5.96203ZM10.5 6.5625V2.89669L14.1652 6.5625H10.5Z"
        fill="black"
      />
    </svg>
  );
};

export const VerificationIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.4296 2.80411L1.86712 6.90568C1.74316 6.93957 1.63266 7.01085 1.55067 7.10981C1.46868 7.20877 1.41919 7.3306 1.40894 7.45871C1.39869 7.58681 1.42819 7.71496 1.4934 7.8257C1.55861 7.93644 1.65638 8.02438 1.77337 8.07755L8.46087 11.2416C8.59188 11.3023 8.69708 11.4075 8.75775 11.5385L11.9218 18.226C11.975 18.343 12.0629 18.4408 12.1737 18.506C12.2844 18.5712 12.4126 18.6007 12.5407 18.5904C12.6688 18.5802 12.7906 18.5307 12.8896 18.4487C12.9885 18.3667 13.0598 18.2562 13.0937 18.1322L17.1953 3.56974C17.2263 3.46347 17.2283 3.3508 17.2008 3.24353C17.1734 3.13627 17.1176 3.03836 17.0393 2.96007C16.961 2.88178 16.8631 2.82599 16.7558 2.79855C16.6486 2.77111 16.5359 2.77303 16.4296 2.80411V2.80411Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66422 11.3359L12.1955 7.80469"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerificationProcessSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.75 16.5L8.25 21L3.75 16.5"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 16.5V8.25C18.75 6.85761 18.1969 5.52226 17.2123 4.53769C16.2277 3.55312 14.8924 3 13.5 3V3C12.1076 3 10.7723 3.55312 9.78769 4.53769C8.80312 5.52226 8.25 6.85761 8.25 8.25V21"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerificationInitiatedLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M5.96094 22.0391C4.95469 21.0328 5.62188 18.9219 5.10781 17.6859C4.59375 16.45 2.625 15.3672 2.625 14C2.625 12.6328 4.57188 11.5938 5.10781 10.3141C5.64375 9.03438 4.95469 6.96719 5.96094 5.96094C6.96719 4.95469 9.07813 5.62188 10.3141 5.10781C11.55 4.59375 12.6328 2.625 14 2.625C15.3672 2.625 16.4062 4.57188 17.6859 5.10781C18.9656 5.64375 21.0328 4.95469 22.0391 5.96094C23.0453 6.96719 22.3781 9.07813 22.8922 10.3141C23.4063 11.55 25.375 12.6328 25.375 14C25.375 15.3672 23.4281 16.4062 22.8922 17.6859C22.3563 18.9656 23.0453 21.0328 22.0391 22.0391C21.0328 23.0453 18.9219 22.3781 17.6859 22.8922C16.45 23.4063 15.3672 25.375 14 25.375C12.6328 25.375 11.5938 23.4281 10.3141 22.8922C9.03438 22.3563 6.96719 23.0453 5.96094 22.0391Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8125 11.375L12.3922 17.5L9.1875 14.4375"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerificationsAcceptedLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M18.8125 11.375L12.3922 17.5L9.1875 14.4375"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerificationsPendingLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 8.75V14"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.55 16.625L14 14"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1465 10.9048H24.5215V6.52979"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8028 20.8031C19.4571 22.15 17.7421 23.0675 15.8748 23.4395C14.0075 23.8115 12.0718 23.6214 10.3126 22.8931C8.55343 22.1648 7.04975 20.9312 5.99179 19.3482C4.93383 17.7652 4.36914 15.904 4.36914 14C4.36914 12.096 4.93383 10.2348 5.99179 8.65182C7.04975 7.06883 8.55343 5.83517 10.3126 5.10691C12.0718 4.37865 14.0075 4.1885 15.8748 4.56052C17.7421 4.93254 19.4571 5.85001 20.8028 7.19688L24.5216 10.9047"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerificationsRejectedLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M21.875 24.5H6.125C5.89294 24.5 5.67038 24.4078 5.50628 24.2437C5.34219 24.0796 5.25 23.8571 5.25 23.625V4.375C5.25 4.14294 5.34219 3.92038 5.50628 3.75628C5.67038 3.59219 5.89294 3.5 6.125 3.5H16.625L22.75 9.625V23.625C22.75 23.8571 22.6578 24.0796 22.4937 24.2437C22.3296 24.4078 22.1071 24.5 21.875 24.5Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.625 3.5V9.625H22.75"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 14L16.625 19.25"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.625 14L11.375 19.25"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TotalIssuer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M4.90079 14.0001C4.90079 11.5866 5.85953 9.27196 7.56611 7.56538C9.2727 5.8588 11.5873 4.90005 14.0008 4.90005C16.4143 4.90005 18.7289 5.8588 20.4355 7.56538C22.142 9.27196 23.1008 11.5866 23.1008 14.0001C23.1008 14.2785 23.2114 14.5456 23.4083 14.7425C23.6052 14.9394 23.8723 15.0501 24.1508 15.0501C24.4293 15.0501 24.6963 14.9394 24.8932 14.7425C25.0902 14.5456 25.2008 14.2785 25.2008 14.0001C25.2008 11.7849 24.5439 9.6195 23.3132 7.77767C22.0826 5.93584 20.3334 4.5003 18.2868 3.6526C16.2403 2.8049 13.9884 2.5831 11.8158 3.01526C9.64319 3.44741 7.64754 4.51411 6.08119 6.08046C4.51484 7.64681 3.44815 9.64246 3.01599 11.815C2.58384 13.9876 2.80563 16.2396 3.65334 18.2861C4.50104 20.3326 5.93657 22.0818 7.7784 23.3125C9.62023 24.5432 11.7856 25.2001 14.0008 25.2001C14.2793 25.2001 14.5463 25.0894 14.7432 24.8925C14.9402 24.6956 15.0508 24.4285 15.0508 24.1501C15.0508 23.8716 14.9402 23.6045 14.7432 23.4076C14.5463 23.2107 14.2793 23.1001 14.0008 23.1001C11.5873 23.1001 9.2727 22.1413 7.56611 20.4347C5.85953 18.7281 4.90079 16.4135 4.90079 14.0001Z"
        fill="#18181B"
      />
      <path
        d="M14.0023 16.1001C14.5593 16.1001 15.0934 15.8789 15.4873 15.4851C15.8811 15.0912 16.1023 14.5571 16.1023 14.0001C16.1023 13.4432 15.8811 12.909 15.4873 12.5152C15.0934 12.1214 14.5593 11.9001 14.0023 11.9001C13.4454 11.9001 12.9112 12.1214 12.5174 12.5152C12.1236 12.909 11.9023 13.4432 11.9023 14.0001C11.9023 14.5571 12.1236 15.0912 12.5174 15.4851C12.9112 15.8789 13.4454 16.1001 14.0023 16.1001ZM19.0045 24.2523L14.9501 20.1979C14.9175 20.1654 14.8917 20.1268 14.874 20.0843C14.8564 20.0418 14.8473 19.9962 14.8473 19.9501C14.8473 19.9041 14.8564 19.8585 14.874 19.816C14.8917 19.7735 14.9175 19.7349 14.9501 19.7023L19.0045 15.6479C19.0535 15.5989 19.1159 15.5654 19.1839 15.5519C19.2519 15.5383 19.3223 15.5453 19.3864 15.5718C19.4504 15.5983 19.5051 15.6433 19.5436 15.701C19.582 15.7586 19.6025 15.8264 19.6023 15.8957V18.9001H24.1523C24.4308 18.9001 24.6979 19.0108 24.8948 19.2077C25.0917 19.4046 25.2023 19.6717 25.2023 19.9501C25.2023 20.2286 25.0917 20.4957 24.8948 20.6926C24.6979 20.8895 24.4308 21.0001 24.1523 21.0001H19.6023V24.0045C19.6025 24.0739 19.582 24.1417 19.5436 24.1993C19.5051 24.257 19.4504 24.302 19.3864 24.3285C19.3223 24.355 19.2519 24.362 19.1839 24.3484C19.1159 24.3349 19.0535 24.3014 19.0045 24.2523Z"
        fill="#00338D"
      />
    </svg>
  );
};

export const TotalissuerLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M5.96094 22.0391C4.95469 21.0328 5.62188 18.9219 5.10781 17.6859C4.59375 16.45 2.625 15.3672 2.625 14C2.625 12.6328 4.57188 11.5938 5.10781 10.3141C5.64375 9.03438 4.95469 6.96719 5.96094 5.96094C6.96719 4.95469 9.07813 5.62188 10.3141 5.10781C11.55 4.59375 12.6328 2.625 14 2.625C15.3672 2.625 16.4062 4.57188 17.6859 5.10781C18.9656 5.64375 21.0328 4.95469 22.0391 5.96094C23.0453 6.96719 22.3781 9.07813 22.8922 10.3141C23.4063 11.55 25.375 12.6328 25.375 14C25.375 15.3672 23.4281 16.4062 22.8922 17.6859C22.3563 18.9656 23.0453 21.0328 22.0391 22.0391C21.0328 23.0453 18.9219 22.3781 17.6859 22.8922C16.45 23.4063 15.3672 25.375 14 25.375C12.6328 25.375 11.5938 23.4281 10.3141 22.8922C9.03438 22.3563 6.96719 23.0453 5.96094 22.0391Z"
        stroke="#18181B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8125 11.375L12.3922 17.5L9.1875 14.4375"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TotalCustomersLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17.5C16.4162 17.5 18.375 15.5412 18.375 13.125C18.375 10.7088 16.4162 8.75 14 8.75C11.5838 8.75 9.625 10.7088 9.625 13.125C9.625 15.5412 11.5838 17.5 14 17.5Z"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.97656 21.81C7.6349 20.5133 8.63946 19.4242 9.87887 18.6635C11.1183 17.9027 12.5442 17.5 13.9984 17.5C15.4527 17.5 16.8786 17.9027 18.118 18.6635C19.3574 19.4242 20.362 20.5133 21.0203 21.81"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TotalHolderLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 19.6875C16.4162 19.6875 18.375 17.7287 18.375 15.3125C18.375 12.8963 16.4162 10.9375 14 10.9375C11.5838 10.9375 9.625 12.8963 9.625 15.3125C9.625 17.7287 11.5838 19.6875 14 19.6875Z"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4375 12.6875C22.4566 12.6858 23.462 12.9223 24.3735 13.378C25.285 13.8338 26.0774 14.4962 26.6875 15.3125"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3125 15.3125C1.92259 14.4962 2.71499 13.8338 3.6265 13.378C4.53801 12.9223 5.5434 12.6858 6.5625 12.6875"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.69922 23.6251C8.27543 22.4451 9.1715 21.4506 10.2853 20.7549C11.3992 20.0593 12.686 19.6904 13.9992 19.6904C15.3124 19.6904 16.5993 20.0593 17.7131 20.7549C18.8269 21.4506 19.723 22.4451 20.2992 23.6251"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.56215 12.6875C5.89785 12.6882 5.24708 12.4998 4.68587 12.1443C4.12466 11.7889 3.6762 11.2811 3.39288 10.6802C3.10956 10.0794 3.00309 9.41031 3.0859 8.75119C3.16871 8.09208 3.43738 7.47014 3.86053 6.95805C4.28368 6.44596 4.84383 6.06486 5.47552 5.8593C6.10721 5.65373 6.78436 5.63218 7.42784 5.79716C8.07133 5.96214 8.65457 6.30684 9.10943 6.79099C9.56428 7.27514 9.87196 7.87873 9.99652 8.53125"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0039 8.53125C18.1285 7.87873 18.4361 7.27514 18.891 6.79099C19.3459 6.30684 19.9291 5.96214 20.5726 5.79716C21.2161 5.63218 21.8932 5.65373 22.5249 5.8593C23.1566 6.06486 23.7167 6.44596 24.1399 6.95805C24.563 7.47014 24.8317 8.09208 24.9145 8.75119C24.9973 9.41031 24.8909 10.0794 24.6075 10.6802C24.3242 11.2811 23.8758 11.7889 23.3146 12.1443C22.7534 12.4998 22.1026 12.6882 21.4383 12.6875"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CameraIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <g clipPath="url(#clip0_1442_39840)">
        <path
          d="M6.68847 4.96826H8.53222M4.38996 13.5724H10.8308C12.527 13.5724 13.2031 12.5338 13.2829 11.2677L13.6025 6.19128C13.6886 4.86378 12.6315 3.73909 11.2978 3.73909C10.9229 3.73909 10.5788 3.52399 10.4067 3.19212L9.9642 2.30097C9.68149 1.7417 8.94399 1.28076 8.31711 1.28076H6.90972C6.27673 1.28076 5.53923 1.7417 5.25652 2.30097L4.81402 3.19212C4.64194 3.52399 4.29777 3.73909 3.92287 3.73909C2.58923 3.73909 1.53214 4.86378 1.61819 6.19128L1.93777 11.2677C2.01152 12.5338 2.69371 13.5724 4.38996 13.5724Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.61068 11.1144C8.71078 11.1144 9.60807 10.2171 9.60807 9.11702C9.60807 8.01692 8.71078 7.11963 7.61068 7.11963C6.51057 7.11963 5.61328 8.01692 5.61328 9.11702C5.61328 10.2171 6.51057 11.1144 7.61068 11.1144Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1442_39840">
          <rect
            width="14.75"
            height="14.75"
            fill="white"
            transform="translate(0.234375 0.0517578)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AdminLogin = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17.5C16.4162 17.5 18.375 15.5412 18.375 13.125C18.375 10.7088 16.4162 8.75 14 8.75C11.5838 8.75 9.625 10.7088 9.625 13.125C9.625 15.5412 11.5838 17.5 14 17.5Z"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.97656 21.8096C7.6349 20.5128 8.63946 19.4237 9.87887 18.663C11.1183 17.9022 12.5442 17.4995 13.9984 17.4995C15.4527 17.4995 16.8786 17.9022 18.118 18.663C19.3574 19.4237 20.362 20.5128 21.0203 21.8096"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WalletIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M24.5 6.125H3.5C3.01675 6.125 2.625 6.51675 2.625 7V21C2.625 21.4832 3.01675 21.875 3.5 21.875H24.5C24.9832 21.875 25.375 21.4832 25.375 21V7C25.375 6.51675 24.9832 6.125 24.5 6.125Z"
        stroke="#18181B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 18.375H21.875"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 18.375H14.875"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 10.5986H25.375"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WalletDarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M24.5 6.125H3.5C3.01675 6.125 2.625 6.51675 2.625 7V21C2.625 21.4832 3.01675 21.875 3.5 21.875H24.5C24.9832 21.875 25.375 21.4832 25.375 21V7C25.375 6.51675 24.9832 6.125 24.5 6.125Z"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.375 18.375H21.875"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.125 18.375H14.875"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.625 10.5986H25.375"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M11.8354 10.7864L11.4235 11.3103L11.8953 11.7809L15.5613 15.4387C15.5614 15.4387 15.5614 15.4387 15.5614 15.4388C15.5776 15.455 15.5867 15.477 15.5867 15.5C15.5867 15.523 15.5776 15.5451 15.5613 15.5613C15.5451 15.5776 15.523 15.5867 15.5 15.5867C15.477 15.5867 15.455 15.5776 15.4388 15.5614C15.4387 15.5614 15.4387 15.5614 15.4387 15.5613L11.7809 11.8953L11.3103 11.4235L10.7864 11.8354C9.75502 12.6465 8.48033 13.0861 7.16826 13.0833H7.16667C6.19291 13.0833 5.23735 12.8431 4.38334 12.3878V12.1957C5.22745 12.6636 6.18366 12.9158 7.16601 12.9167V12.9167L7.17231 12.9166C8.50347 12.9066 9.78992 12.4351 10.8122 11.5824C11.8344 10.7297 12.5292 9.54876 12.7779 8.24099C13.0266 6.93323 12.8138 5.57969 12.1759 4.4113C11.5379 3.24292 10.5143 2.33207 9.27977 1.83416C8.04519 1.33626 6.6761 1.28214 5.40608 1.68104C4.13605 2.07994 3.04378 2.90715 2.31561 4.02154C1.58743 5.13593 1.26848 6.46844 1.41317 7.79176C1.55785 9.11507 2.1572 10.3472 3.10897 11.2779L4.04387 12.1921C3.98858 12.1578 3.9338 12.1224 3.87955 12.0862C2.90655 11.4361 2.1482 10.512 1.70038 9.43088C1.25256 8.34975 1.13539 7.16011 1.36369 6.01239C1.59199 4.86466 2.15549 3.81042 2.98295 2.98295C3.81042 2.15549 4.86466 1.59199 6.01239 1.36369C7.16011 1.13539 8.34975 1.25256 9.43088 1.70038C10.512 2.1482 11.4361 2.90655 12.0862 3.87955C12.7363 4.85254 13.0833 5.99646 13.0833 7.16667L13.0833 7.16826C13.0861 8.48033 12.6465 9.75502 11.8354 10.7864Z"
        fill="#335CA4"
        stroke="#335CA4"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UserManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11.3789 18.875C15.7281 18.875 19.2539 15.3492 19.2539 11C19.2539 6.65076 15.7281 3.125 11.3789 3.125C7.02966 3.125 3.50391 6.65076 3.50391 11C3.50391 15.3492 7.02966 18.875 11.3789 18.875Z"
        stroke="#18181B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3789 13.625C13.1911 13.625 14.6602 12.1559 14.6602 10.3438C14.6602 8.53157 13.1911 7.0625 11.3789 7.0625C9.56672 7.0625 8.09766 8.53157 8.09766 10.3438C8.09766 12.1559 9.56672 13.625 11.3789 13.625Z"
        stroke="#18181B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.11328 16.857C6.60704 15.8845 7.36045 15.0677 8.29002 14.4971C9.21958 13.9265 10.289 13.6245 11.3797 13.6245C12.4704 13.6245 13.5398 13.9265 14.4694 14.4971C15.3989 15.0677 16.1523 15.8845 16.6461 16.857"
        stroke="#18181B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WalletManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M19.2539 5.09375H3.50391C3.14147 5.09375 2.84766 5.38756 2.84766 5.75V16.25C2.84766 16.6124 3.14147 16.9062 3.50391 16.9062H19.2539C19.6163 16.9062 19.9102 16.6124 19.9102 16.25V5.75C19.9102 5.38756 19.6163 5.09375 19.2539 5.09375Z"
        stroke="#18181B"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6602 14.2812H17.2852"
        stroke="#00338D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7227 14.2812H12.0352"
        stroke="#00338D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.84766 8.44922H19.9102"
        stroke="#18181B"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TransactionManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M10.0664 14.9375L7.44141 17.5625L4.81641 14.9375"
        stroke="#00338D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44141 4.4375V17.5625"
        stroke="#18181B"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6914 7.0625L15.3164 4.4375L17.9414 7.0625"
        stroke="#00338D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3164 17.5625V4.4375"
        stroke="#18181B"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AnalyticsIcon = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="9" y="9" width="20" height="20" rx="4" fill="#E6EBF4" />
    <path
      d="M2.25 11.9997C12 -9.00032 12 32.9997 21.75 11.9997"
      stroke="#18181B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TransactionIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M12.25 19.25L8.75 22.75L5.25 19.25"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 5.25V22.75"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 8.75L19.25 5.25L22.75 8.75"
        stroke="#00338D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 22.75V5.25"
        stroke="#18181B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon = ({ active = false }) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 38.5C33.799 38.5 38.5 33.799 38.5 28C38.5 22.201 33.799 17.5 28 17.5C22.201 17.5 17.5 22.201 17.5 28C17.5 33.799 22.201 38.5 28 38.5Z"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 31.5C30.4162 31.5 32.375 29.5412 32.375 27.125C32.375 24.7088 30.4162 22.75 28 22.75C25.5838 22.75 23.625 24.7088 23.625 27.125C23.625 29.5412 25.5838 31.5 28 31.5Z"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9785 35.8096C21.6369 34.5128 22.6414 33.4237 23.8808 32.663C25.1202 31.9022 26.5461 31.4995 28.0004 31.4995C29.4547 31.4995 30.8805 31.9022 32.12 32.663C33.3594 33.4237 34.3639 34.5128 35.0223 35.8096"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter0_d_3867_48256)">
      <circle cx="36" cy="36" r="3" fill={active ? "#1EBB10" : "#FD3A3A"} />
    </g>
    <defs>
      <filter
        id="filter0_d_3867_48256"
        x="29"
        y="33"
        width="14"
        height="14"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3867_48256"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3867_48256"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const GraphLegendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="9"
      viewBox="0 0 23 9"
      fill="none"
    >
      <path
        d="M2 4.5H21"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="11.5" cy="4.5" r="4.5" fill="currentColor" />
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08301 10.6665L11.833 15.3332C12.1663 15.6665 12.6663 15.6665 12.9997 15.3332C13.333 14.9998 13.333 14.4998 12.9997 14.1665L8.91634 9.99984L12.9997 5.83317C13.333 5.49984 13.333 4.99984 12.9997 4.6665C12.833 4.49984 12.6663 4.4165 12.4163 4.4165C12.1663 4.4165 11.9997 4.49984 11.833 4.6665L7.08301 9.33317C6.74967 9.74984 6.74967 10.2498 7.08301 10.6665C7.08301 10.5832 7.08301 10.5832 7.08301 10.6665Z"
        fill="black"
      />
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9499 9.40845L8.23328 4.70011C8.15581 4.622 8.06364 4.56001 7.96209 4.5177C7.86054 4.4754 7.75162 4.45361 7.64161 4.45361C7.5316 4.45361 7.42268 4.4754 7.32113 4.5177C7.21958 4.56001 7.12741 4.622 7.04994 4.70011C6.89474 4.85625 6.80762 5.06746 6.80762 5.28761C6.80762 5.50777 6.89474 5.71898 7.04994 5.87511L11.1749 10.0418L7.04994 14.1668C6.89474 14.3229 6.80762 14.5341 6.80762 14.7543C6.80762 14.9744 6.89474 15.1856 7.04994 15.3418C7.12712 15.4205 7.21916 15.4832 7.32072 15.5261C7.42229 15.569 7.53135 15.5913 7.64161 15.5918C7.75187 15.5913 7.86094 15.569 7.9625 15.5261C8.06406 15.4832 8.1561 15.4205 8.23328 15.3418L12.9499 10.6334C13.0345 10.5554 13.102 10.4607 13.1482 10.3553C13.1944 10.2499 13.2182 10.136 13.2182 10.0209C13.2182 9.90586 13.1944 9.79202 13.1482 9.68661C13.102 9.58119 13.0345 9.48648 12.9499 9.40845Z"
        fill="black"
      />
    </svg>
  );
};

export const HamburgerIcon = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      style={{ mixBlendMode: "difference" }}
    >
      <path
        className={`${isOpen ? "invisible" : "visible"}`}
        d="M4.375 14H23.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* top */}
      <path
        className={`transition-all duration-500 ease-in-out ${isOpen ? "origin-left -translate-x-[2px] -translate-y-[7px]  rotate-45 rounded-md outline outline-black" : "translate-x-0 translate-y-0 rotate-0 rounded-none outline-none"} `}
        d="M4.375 7H23.625"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* bottom */}
      <path
        className={`transition-all duration-500 ease-in-out ${isOpen ? "-translate-x-3 translate-y-2 -rotate-45 rounded-md outline outline-black" : "translate-x-0 translate-y-0 rotate-0 rounded-none outline-none"} `}
        d="M4.375 21H23.625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Applelogo = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6449 8.32378C11.6959 8.32378 10.2269 7.24478 8.67986 7.28378C6.63886 7.30978 4.76686 8.46677 3.71386 10.2998C1.59486 13.9788 3.16786 19.4128 5.23486 22.4028C6.24886 23.8588 7.44486 25.4968 9.03086 25.4448C10.5519 25.3798 11.1239 24.4568 12.9699 24.4568C14.8029 24.4568 15.3229 25.4448 16.9349 25.4058C18.5729 25.3798 19.6129 23.9238 20.6139 22.4548C21.7709 20.7648 22.2519 19.1268 22.2779 19.0358C22.2389 19.0228 19.0929 17.8138 19.0539 14.1738C19.0279 11.1318 21.5369 9.67578 21.6539 9.61078C20.2239 7.51778 18.0269 7.28378 17.2599 7.23178C15.2579 7.07578 13.5809 8.32378 12.6449 8.32378ZM16.0249 5.25578C16.8699 4.24178 17.4289 2.82478 17.2729 1.42078C16.0639 1.47278 14.6079 2.22678 13.7369 3.24078C12.9569 4.13778 12.2809 5.58078 12.4629 6.95878C13.8019 7.06278 15.1799 6.26978 16.0249 5.25578Z"
        fill="white"
      />
    </svg>
  );
};

export const PlayStorelogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
    >
      <g clipPath="url(#clip0_6383_6518)">
        <path
          d="M10.2757 11.9417L0.09375 22.4698C0.208092 22.8698 0.413569 23.2386 0.694472 23.5481C0.975376 23.8576 1.32427 24.0997 1.71448 24.2558C2.1047 24.4118 2.5259 24.4778 2.94589 24.4485C3.36588 24.4193 3.77355 24.2957 4.13772 24.0872L15.5943 17.6475L10.2757 11.9417Z"
          fill="#F83548"
        />
        <path
          d="M20.5699 10.1521L15.6157 7.35144L10.0391 12.1811L15.6383 17.6324L20.5548 14.8618C20.9904 14.6367 21.3552 14.2983 21.6097 13.8832C21.8643 13.4681 21.9988 12.9921 21.9988 12.5069C21.9988 12.0217 21.8643 11.5457 21.6097 11.1306C21.3552 10.7155 20.9904 10.3771 20.5548 10.152H20.57L20.5699 10.1521Z"
          fill="#FFD100"
        />
        <path
          d="M0.0911127 2.49182C0.0295686 2.71637 -0.0010679 2.94808 2.84109e-05 3.1807V21.7809C0.000666502 22.0134 0.0312736 22.2449 0.0911127 22.4698L10.6221 12.2112L0.0911127 2.49182Z"
          fill="url(#paint0_linear_6383_6518)"
        />
        <path
          d="M10.3516 12.4808L15.6171 7.35154L4.1757 0.881885C3.74523 0.633071 3.25563 0.501305 2.75676 0.500005C1.51879 0.497631 0.430418 1.30854 0.09375 2.48437L10.3516 12.4808Z"
          fill="#00F076"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6383_6518"
          x1="5.31104"
          y1="2.49182"
          x2="-0.000711806"
          y2="23.8677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00B1D0" />
          <stop offset="1" stopColor="#88F0FF" />
        </linearGradient>
        <clipPath id="clip0_6383_6518">
          <rect
            width="22"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Microsoftlogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <rect y="0.5" width="10" height="10" fill="#F25022" />
      <rect y="11.5" width="10" height="10" fill="#00A4EF" />
      <rect x="11" y="11.5" width="10" height="10" fill="#FFB900" />
      <rect x="11" y="0.5" width="10" height="10" fill="#7FBA00" />
    </svg>
  );
};

export const SearchGreyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M17.0959 15.4364L16.684 15.9603L17.1558 16.4309L21.5552 20.8203C21.5553 20.8204 21.5554 20.8206 21.5555 20.8207C21.6029 20.8683 21.6296 20.9328 21.6296 21C21.6296 21.0674 21.6028 21.132 21.5552 21.1797L22.0855 21.71L21.5552 21.1797C21.5075 21.2273 21.4429 21.2541 21.3755 21.2541C21.3083 21.2541 21.2438 21.2275 21.1962 21.18C21.196 21.1799 21.1959 21.1798 21.1958 21.1797L16.8064 16.7803L16.3357 16.3085L15.8119 16.7204C14.5477 17.7145 12.9853 18.2534 11.3771 18.25H11.3755C9.94158 18.25 8.53987 17.8248 7.34761 17.0282C6.15535 16.2315 5.2261 15.0992 4.67737 13.7745C4.12863 12.4497 3.98506 10.992 4.2648 9.5856C4.54454 8.17924 5.23504 6.88741 6.24897 5.87348C7.2629 4.85955 8.55473 4.16905 9.96109 3.88931C11.3675 3.60957 12.8252 3.75314 14.1499 4.30188C15.4747 4.85061 16.607 5.77986 17.4036 6.97212C18.2003 8.16438 18.6255 9.56609 18.6255 11L18.6255 11.0016C18.6289 12.6098 18.09 14.1722 17.0959 15.4364ZM6.61113 15.8262L7.88549 17.0724V16.7746C8.92936 17.4064 10.1344 17.7489 11.3748 17.75V17.75L11.3811 17.75C12.9438 17.7382 14.454 17.1847 15.654 16.1837C16.8541 15.1827 17.6696 13.7964 17.9616 12.2612C18.2535 10.726 18.0037 9.13703 17.2549 7.76545C16.506 6.39386 15.3044 5.32461 13.8551 4.74011C12.4058 4.15561 10.7986 4.09208 9.30773 4.56036C7.81683 5.02863 6.53459 5.9997 5.67978 7.3079C4.82497 8.61609 4.45055 10.1804 4.6204 11.7338C4.79024 13.2873 5.49383 14.7337 6.61113 15.8262Z"
        fill="#888FA1"
        stroke="#888FA1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const QRIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8894_61144)">
        <path
          d="M9.75 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V9.75C4.5 10.1642 4.83579 10.5 5.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V5.25C10.5 4.83579 10.1642 4.5 9.75 4.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 13.5H5.25C4.83579 13.5 4.5 13.8358 4.5 14.25V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H9.75C10.1642 19.5 10.5 19.1642 10.5 18.75V14.25C10.5 13.8358 10.1642 13.5 9.75 13.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 4.5H14.25C13.8358 4.5 13.5 4.83579 13.5 5.25V9.75C13.5 10.1642 13.8358 10.5 14.25 10.5H18.75C19.1642 10.5 19.5 10.1642 19.5 9.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 13.5V16.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 19.5H16.5V13.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 15H19.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5 18V19.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8894_61144">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LoaderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V6.28571M17.7143 6.28571L16 8M6.28571 6.28571L8 8M12 20V17.7143M17.7143 17.7143L16 16M6.28571 17.7143L8 16M4 12H6.28571M17.7143 12H20"
        stroke="#7B7B80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CertificateIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C12 15.7956 12.3161 16.5587 12.8787 17.1213C13.4413 17.6839 14.2044 18 15 18C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15C18 14.2044 17.6839 13.4413 17.1213 12.8787C16.5587 12.3161 15.7956 12 15 12C14.2044 12 13.4413 12.3161 12.8787 12.8787C12.3161 13.4413 12 14.2044 12 15Z"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 17.5V22L15 20.5L17 22V17.5"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7C3 5.9 3.9 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C20.9996 17.3507 20.9071 17.6952 20.7315 17.9988C20.556 18.3025 20.3037 18.5546 20 18.73M6 9H18M6 12H9M6 15H8"
        stroke="#7B7B80"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CertificateColorIcon = (props: SVGProps<SVGSVGElement>) => {
  const { color } = props;
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 14.25H15.75V16.5H2.25V14.25ZM11.865 12.75H14.433L10.5 2.25H7.5L3.567 12.75H6.13575L6.93525 10.125H11.0648L11.865 12.75ZM10.401 8.25H7.6035L9.0045 3.95625L10.401 8.25Z"
        fill="black"
      />
      <line
        x1="2"
        y1="15.5"
        x2="16"
        y2="15.5"
        stroke="url(#paint0_linear_12121_44611)"
        strokeWidth="3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12121_44611"
          x1="2"
          y1="17.5"
          x2="16"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="0.206731" stopColor={color} />
          <stop offset="0.413462" stopColor={color} />
          <stop offset="0.591346" stopColor={color} />
          <stop offset="0.817308" stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const CertificateTempIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.625 2.625H4.375C3.4085 2.625 2.625 3.4085 2.625 4.375V16.625C2.625 17.5915 3.4085 18.375 4.375 18.375H16.625C17.5915 18.375 18.375 17.5915 18.375 16.625V4.375C18.375 3.4085 17.5915 2.625 16.625 2.625Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 7.875H10.5H18.375M7.875 18.375V7.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CertificateVariableIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 7.21875L1.3125 10.5L5.25 13.7812"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 7.21875L19.6875 10.5L15.75 13.7812"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 3.28125L7.875 17.7188"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CertificateImageIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3111 8.74125C12.5274 7.94675 7.53988 12.2412 7.875 17.9375M5.6875 7C5.6875 7.46413 5.87187 7.90925 6.20006 8.23744C6.52825 8.56563 6.97337 8.75 7.4375 8.75C7.90163 8.75 8.34675 8.56563 8.67494 8.23744C9.00313 7.90925 9.1875 7.46413 9.1875 7C9.1875 6.53587 9.00313 6.09075 8.67494 5.76256C8.34675 5.43437 7.90163 5.25 7.4375 5.25C6.97337 5.25 6.52825 5.43437 6.20006 5.76256C5.87187 6.09075 5.6875 6.53587 5.6875 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 11.4325C5.0575 11.0956 7.24062 12.2707 8.421 14.145"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.625 8.225C2.625 6.265 2.625 5.285 3.0065 4.536C3.34205 3.87746 3.87746 3.34205 4.536 3.0065C5.285 2.625 6.265 2.625 8.225 2.625H12.775C14.735 2.625 15.715 2.625 16.464 3.0065C17.1225 3.34205 17.6579 3.87746 17.9935 4.536C18.375 5.285 18.375 6.265 18.375 8.225V12.775C18.375 14.735 18.375 15.715 17.9935 16.464C17.6579 17.1225 17.1225 17.6579 16.464 17.9935C15.715 18.375 14.735 18.375 12.775 18.375H8.225C6.265 18.375 5.285 18.375 4.536 17.9935C3.87746 17.6579 3.34205 17.1225 3.0065 16.464C2.625 15.715 2.625 14.735 2.625 12.775V8.225Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CertificateTextIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.94225 1.75H14.0577C14.833 1.75 15.5015 1.75 16.037 1.82175C16.6101 1.89875 17.1605 2.07287 17.6059 2.51912C18.0521 2.96537 18.2262 3.51487 18.3032 4.088C18.375 4.6235 18.375 5.292 18.375 6.06725V6.95625C18.375 7.18831 18.2828 7.41087 18.1187 7.57497C17.9546 7.73906 17.7321 7.83125 17.5 7.83125C17.2679 7.83125 17.0454 7.73906 16.8813 7.57497C16.7172 7.41087 16.625 7.18831 16.625 6.95625V6.125C16.625 5.27537 16.6233 4.72588 16.569 4.32163C16.5174 3.94188 16.4351 3.82288 16.3686 3.75638C16.3021 3.68988 16.1831 3.60763 15.8034 3.556C15.4 3.50175 14.8496 3.5 14 3.5H11.375V18.375C11.375 18.6071 11.2828 18.8296 11.1187 18.9937C10.9546 19.1578 10.7321 19.25 10.5 19.25C10.2679 19.25 10.0454 19.1578 9.88128 18.9937C9.71719 18.8296 9.625 18.6071 9.625 18.375V3.5H7C6.15037 3.5 5.60088 3.50175 5.19663 3.556C4.81688 3.60763 4.69788 3.68988 4.63138 3.75638C4.56488 3.82288 4.48263 3.94188 4.431 4.32163C4.37675 4.725 4.375 5.27537 4.375 6.125V6.95625C4.375 7.18831 4.28281 7.41087 4.11872 7.57497C3.95462 7.73906 3.73206 7.83125 3.5 7.83125C3.26794 7.83125 3.04538 7.73906 2.88128 7.57497C2.71719 7.41087 2.625 7.18831 2.625 6.95625V6.06725C2.625 5.292 2.625 4.6235 2.69675 4.088C2.77375 3.51487 2.94787 2.9645 3.39412 2.51912C3.84037 2.07287 4.38987 1.89875 4.963 1.82175C5.4985 1.75 6.167 1.75 6.94225 1.75Z"
        fill="currentColor"
      />
      <path
        d="M6.125 18.375H14.875"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CertificateIcon1 = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3799 13.625C11.3799 14.3212 11.6564 14.9889 12.1487 15.4812C12.641 15.9734 13.3087 16.25 14.0049 16.25C14.7011 16.25 15.3688 15.9734 15.861 15.4812C16.3533 14.9889 16.6299 14.3212 16.6299 13.625C16.6299 12.9288 16.3533 12.2611 15.861 11.7688C15.3688 11.2766 14.7011 11 14.0049 11C13.3087 11 12.641 11.2766 12.1487 11.7688C11.6564 12.2611 11.3799 12.9288 11.3799 13.625Z"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2549 15.8125V19.75L14.0049 18.4375L15.7549 19.75V15.8125"
        stroke="#00338D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.62988 17.125H5.25488C4.79075 17.125 4.34563 16.9406 4.01745 16.6124C3.68926 16.2842 3.50488 15.8391 3.50488 15.375V6.625C3.50488 5.6625 4.29238 4.875 5.25488 4.875H17.5049C17.969 4.875 18.4141 5.05937 18.7423 5.38756C19.0705 5.71575 19.2549 6.16087 19.2549 6.625V15.375C19.2546 15.6819 19.1736 15.9833 19.02 16.249C18.8664 16.5147 18.6457 16.7353 18.3799 16.8887M6.12988 8.375H16.6299M6.12988 11H8.75488M6.12988 13.625H7.87988"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CertificateAlignIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 13.5C10.6912 13.5002 10.875 13.5734 11.014 13.7046C11.153 13.8359 11.2367 14.0152 11.2479 14.206C11.2591 14.3969 11.197 14.5848 11.0743 14.7314C10.9516 14.878 10.7776 14.9722 10.5877 14.9948L10.5 15H3C2.80884 14.9998 2.62498 14.9266 2.48597 14.7954C2.34697 14.6641 2.26332 14.4848 2.25212 14.294C2.24092 14.1031 2.30301 13.9152 2.4257 13.7686C2.54839 13.622 2.72243 13.5278 2.91225 13.5052L3 13.5H10.5ZM15 9.75C15.1989 9.75 15.3897 9.82902 15.5303 9.96967C15.671 10.1103 15.75 10.3011 15.75 10.5C15.75 10.6989 15.671 10.8897 15.5303 11.0303C15.3897 11.171 15.1989 11.25 15 11.25H3C2.80109 11.25 2.61032 11.171 2.46967 11.0303C2.32902 10.8897 2.25 10.6989 2.25 10.5C2.25 10.3011 2.32902 10.1103 2.46967 9.96967C2.61032 9.82902 2.80109 9.75 3 9.75H15ZM10.5 6C10.6912 6.00021 10.875 6.07341 11.014 6.20464C11.153 6.33586 11.2367 6.51521 11.2479 6.70605C11.2591 6.89688 11.197 7.08478 11.0743 7.23137C10.9516 7.37796 10.7776 7.47217 10.5877 7.49475L10.5 7.5H3C2.80884 7.49979 2.62498 7.42659 2.48597 7.29536C2.34697 7.16414 2.26332 6.98479 2.25212 6.79395C2.24092 6.60312 2.30301 6.41522 2.4257 6.26863C2.54839 6.12204 2.72243 6.02783 2.91225 6.00525L3 6H10.5ZM15 2.25C15.1912 2.25021 15.375 2.32341 15.514 2.45464C15.653 2.58586 15.7367 2.76521 15.7479 2.95605C15.7591 3.14688 15.697 3.33478 15.5743 3.48137C15.4516 3.62796 15.2776 3.72217 15.0878 3.74475L15 3.75H3C2.80884 3.74979 2.62498 3.67659 2.48597 3.54536C2.34697 3.41414 2.26332 3.23479 2.25212 3.04395C2.24092 2.85312 2.30301 2.66522 2.4257 2.51863C2.54839 2.37204 2.72243 2.27783 2.91225 2.25525L3 2.25H15Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CertificateLetterSpaceIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 5.88712L3.075 6.54337C2.9375 6.68087 2.76575 6.74962 2.55975 6.74962C2.35375 6.74962 2.1755 6.67462 2.025 6.52462C1.8875 6.38712 1.81875 6.21212 1.81875 5.99962C1.81875 5.78712 1.8875 5.61212 2.025 5.47462L3.975 3.52462C4.05 3.44962 4.13125 3.39662 4.21875 3.36562C4.30625 3.33462 4.4 3.31887 4.5 3.31837C4.6 3.31787 4.69375 3.33362 4.78125 3.36562C4.86875 3.39762 4.95 3.45062 5.025 3.52462L6.975 5.47462C7.1125 5.61212 7.1845 5.78412 7.191 5.99062C7.1975 6.19712 7.1255 6.37512 6.975 6.52462C6.8375 6.66212 6.66575 6.73412 6.45975 6.74062C6.25375 6.74712 6.0755 6.68137 5.925 6.54337L5.25 5.88712V12.1121L5.925 11.4559C6.0625 11.3184 6.2345 11.2496 6.441 11.2496C6.6475 11.2496 6.8255 11.3246 6.975 11.4746C7.1125 11.6121 7.18125 11.7871 7.18125 11.9996C7.18125 12.2121 7.1125 12.3871 6.975 12.5246L5.025 14.4746C4.95 14.5496 4.86875 14.6029 4.78125 14.6344C4.69375 14.6659 4.6 14.6814 4.5 14.6809C4.4 14.6804 4.30625 14.6649 4.21875 14.6344C4.13125 14.6039 4.05 14.5506 3.975 14.4746L2.025 12.5246C1.8875 12.3871 1.8155 12.2154 1.809 12.0094C1.8025 11.8034 1.8745 11.6251 2.025 11.4746C2.1625 11.3371 2.3345 11.2651 2.541 11.2586C2.7475 11.2521 2.9255 11.3179 3.075 11.4559L3.75 12.1121V5.88712ZM9.75 14.2496C9.5375 14.2496 9.3595 14.1776 9.216 14.0336C9.0725 13.8896 9.0005 13.7116 9 13.4996C8.9995 13.2876 9.0715 13.1096 9.216 12.9656C9.3605 12.8216 9.5385 12.7496 9.75 12.7496H15.75C15.9625 12.7496 16.1407 12.8216 16.2847 12.9656C16.4287 13.1096 16.5005 13.2876 16.5 13.4996C16.4995 13.7116 16.4275 13.8899 16.284 14.0344C16.1405 14.1789 15.9625 14.2506 15.75 14.2496H9.75ZM9.75 9.74962C9.5375 9.74962 9.3595 9.67762 9.216 9.53362C9.0725 9.38962 9.0005 9.21162 9 8.99962C8.9995 8.78762 9.0715 8.60962 9.216 8.46562C9.3605 8.32162 9.5385 8.24962 9.75 8.24962H15.75C15.9625 8.24962 16.1407 8.32162 16.2847 8.46562C16.4287 8.60962 16.5005 8.78762 16.5 8.99962C16.4995 9.21162 16.4275 9.38987 16.284 9.53437C16.1405 9.67887 15.9625 9.75062 15.75 9.74962H9.75ZM9.75 5.24962C9.5375 5.24962 9.3595 5.17762 9.216 5.03362C9.0725 4.88962 9.0005 4.71162 9 4.49962C8.9995 4.28762 9.0715 4.10962 9.216 3.96562C9.3605 3.82162 9.5385 3.74962 9.75 3.74962H15.75C15.9625 3.74962 16.1407 3.82162 16.2847 3.96562C16.4287 4.10962 16.5005 4.28762 16.5 4.49962C16.4995 4.71162 16.4275 4.88987 16.284 5.03437C16.1405 5.17887 15.9625 5.25062 15.75 5.24962H9.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12149_26458)">
      <path
        d="M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 23.986 5.851 30.6054 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5435 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.1199 10.5 18.5 11.7334 18.5 12.9987V16H22.9375L22.2281 20.625H18.5V31.8056C26.149 30.6054 32 23.9861 32 16Z"
        fill="#1877F2"
      />
      <path
        d="M22.2281 20.625L22.9375 16H18.5V12.9987C18.5 11.7332 19.1199 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.294 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.327 31.9352 15.1629 32.0002 16 32C16.8371 32.0002 17.673 31.9352 18.5 31.8056V20.625H22.2281Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12149_26458">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhatsAppIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12149_26461)">
      <path
        d="M0.683437 15.809C0.682687 18.4977 1.39069 21.1229 2.73694 23.4368L0.554688 31.3428L8.70869 29.2214C10.964 30.4396 13.4909 31.0779 16.0587 31.0781H16.0654C24.5423 31.0781 31.4427 24.2337 31.4463 15.8211C31.4479 11.7445 29.8494 7.91125 26.9452 5.02728C24.0414 2.14356 20.1796 0.554595 16.0648 0.552734C7.58694 0.552734 0.687063 7.39677 0.683563 15.809"
        fill="url(#paint0_linear_12149_26461)"
      />
      <path
        d="M0.13375 15.8035C0.132875 18.5889 0.86625 21.308 2.2605 23.7048L0 31.8942L8.44637 29.6967C10.7736 30.9558 13.3939 31.6196 16.0601 31.6206H16.067C24.848 31.6206 31.9963 24.53 32 15.8162C32.0015 11.5932 30.3455 7.62208 27.3375 4.63479C24.3291 1.64788 20.3291 0.00173643 16.067 0C7.2845 0 0.13725 7.08961 0.13375 15.8035ZM5.16388 23.292L4.8485 22.7953C3.52275 20.7036 2.823 18.2865 2.824 15.8045C2.82675 8.56174 8.76725 2.66915 16.072 2.66915C19.6095 2.67064 22.934 4.03895 25.4345 6.52155C27.9349 9.0044 29.3108 12.3049 29.3099 15.8152C29.3066 23.058 23.366 28.9513 16.067 28.9513H16.0618C13.6851 28.9501 11.3542 28.3168 9.3215 27.12L8.83775 26.8353L3.8255 28.1393L5.16388 23.292Z"
        fill="url(#paint1_linear_12149_26461)"
      />
      <path
        d="M12.0845 9.19759C11.7862 8.53986 11.4723 8.52658 11.1887 8.51505C10.9565 8.50513 10.691 8.50587 10.4257 8.50587C10.1602 8.50587 9.72883 8.60497 9.3642 9.00001C8.9992 9.39542 7.9707 10.351 7.9707 12.2944C7.9707 14.2378 9.39733 16.1162 9.5962 16.38C9.79533 16.6433 12.3503 20.7591 16.3968 22.3425C19.7598 23.6584 20.4442 23.3967 21.1741 23.3307C21.9041 23.2649 23.5296 22.3754 23.8612 21.453C24.1931 20.5307 24.1931 19.7401 24.0936 19.5749C23.9941 19.4103 23.7286 19.3115 23.3305 19.114C22.9323 18.9165 20.975 17.9608 20.6101 17.8289C20.2451 17.6972 19.9797 17.6315 19.7142 18.027C19.4487 18.4219 18.6863 19.3115 18.454 19.5749C18.2218 19.839 17.9895 19.8718 17.5915 19.6742C17.1931 19.476 15.911 19.0594 14.3898 17.7138C13.2063 16.6667 12.4073 15.3737 12.1751 14.9782C11.9428 14.5833 12.1502 14.3692 12.3498 14.1724C12.5287 13.9954 12.7481 13.7111 12.9473 13.4805C13.1458 13.2498 13.2121 13.0852 13.3448 12.8218C13.4777 12.5581 13.4112 12.3274 13.3118 12.1298C13.2121 11.9322 12.4385 9.97862 12.0845 9.19759Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_12149_26461"
        x1={1545.14}
        y1={3079.56}
        x2={1545.14}
        y2={0.552734}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1FAF38" />
        <stop offset={1} stopColor="#60D669" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12149_26461"
        x1={1600}
        y1={3189.42}
        x2={1600}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F9F9" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_12149_26461">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InstagramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12149_26465)">
      <path
        d="M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z"
        fill="url(#paint0_radial_12149_26465)"
      />
      <path
        d="M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z"
        fill="url(#paint1_radial_12149_26465)"
      />
      <path
        d="M16.0011 3.5C12.6064 3.5 12.1803 3.51488 10.847 3.5755C9.51625 3.6365 8.60787 3.84712 7.81313 4.15625C6.99088 4.4755 6.2935 4.90262 5.59875 5.59762C4.90338 6.2925 4.47625 6.98987 4.156 7.81175C3.846 8.60675 3.63512 9.5155 3.57525 10.8456C3.51562 12.179 3.5 12.6053 3.5 16.0001C3.5 19.395 3.515 19.8197 3.5755 21.153C3.63675 22.4837 3.84738 23.3921 4.15625 24.1869C4.47575 25.0091 4.90288 25.7065 5.59788 26.4013C6.2925 27.0966 6.98988 27.5247 7.8115 27.844C8.60687 28.1531 9.51537 28.3637 10.8459 28.4247C12.1792 28.4854 12.605 28.5002 15.9996 28.5002C19.3948 28.5002 19.8195 28.4854 21.1528 28.4247C22.4835 28.3637 23.3929 28.1531 24.1882 27.844C25.0101 27.5247 25.7065 27.0966 26.401 26.4013C27.0964 25.7065 27.5234 25.0091 27.8438 24.1873C28.151 23.3921 28.362 22.4835 28.4245 21.1532C28.4844 19.82 28.5 19.395 28.5 16.0001C28.5 12.6053 28.4844 12.1792 28.4245 10.8459C28.362 9.51512 28.151 8.60688 27.8438 7.81213C27.5234 6.98988 27.0964 6.2925 26.401 5.59762C25.7057 4.90237 25.0104 4.47525 24.1875 4.15637C23.3906 3.84712 22.4817 3.63638 21.151 3.5755C19.8176 3.51488 19.3931 3.5 15.9972 3.5H16.0011ZM14.8798 5.75262C15.2126 5.75213 15.584 5.75262 16.0011 5.75262C19.3388 5.75262 19.7342 5.76463 21.0522 5.8245C22.271 5.88025 22.9325 6.08388 23.3731 6.255C23.9565 6.4815 24.3724 6.75238 24.8096 7.19C25.2471 7.6275 25.5179 8.04412 25.745 8.6275C25.9161 9.0675 26.12 9.729 26.1755 10.9478C26.2354 12.2655 26.2484 12.6612 26.2484 15.9972C26.2484 19.3333 26.2354 19.7291 26.1755 21.0467C26.1198 22.2655 25.9161 22.927 25.745 23.3671C25.5185 23.9505 25.2471 24.3659 24.8096 24.8031C24.3721 25.2406 23.9568 25.5114 23.3731 25.738C22.933 25.9099 22.271 26.113 21.0522 26.1688C19.7345 26.2286 19.3388 26.2416 16.0011 26.2416C12.6634 26.2416 12.2677 26.2286 10.9501 26.1688C9.73137 26.1125 9.06987 25.9089 8.62887 25.7377C8.04562 25.5111 7.62887 25.2404 7.19137 24.8029C6.75387 24.3654 6.48312 23.9498 6.256 23.3661C6.08488 22.926 5.881 22.2645 5.8255 21.0457C5.76562 19.728 5.75362 19.3323 5.75362 15.9941C5.75362 12.656 5.76562 12.2624 5.8255 10.9446C5.88125 9.72587 6.08488 9.06437 6.256 8.62375C6.48263 8.04037 6.75388 7.62375 7.1915 7.18625C7.62913 6.74875 8.04562 6.47787 8.629 6.25087C9.06962 6.079 9.73137 5.87587 10.9501 5.81987C12.1032 5.76775 12.5501 5.75212 14.8798 5.7495V5.75262ZM22.6736 7.82812C21.8455 7.82812 21.1736 8.49938 21.1736 9.32763C21.1736 10.1558 21.8455 10.8276 22.6736 10.8276C23.5018 10.8276 24.1736 10.1558 24.1736 9.32763C24.1736 8.4995 23.5018 7.82762 22.6736 7.82762V7.82812ZM16.0011 9.58075C12.4561 9.58075 9.58187 12.455 9.58187 16.0001C9.58187 19.5452 12.4561 22.4181 16.0011 22.4181C19.5462 22.4181 22.4195 19.5452 22.4195 16.0001C22.4195 12.4551 19.546 9.58075 16.0009 9.58075H16.0011ZM16.0011 11.8334C18.3022 11.8334 20.1679 13.6988 20.1679 16.0001C20.1679 18.3013 18.3022 20.1669 16.0011 20.1669C13.7 20.1669 11.8345 18.3013 11.8345 16.0001C11.8345 13.6988 13.6999 11.8334 16.0011 11.8334Z"
        fill="white"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_12149_26465"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.5 34.4646) rotate(-90) scale(31.7144 29.4969)"
      >
        <stop stopColor="#FFDD55" />
        <stop offset={0.1} stopColor="#FFDD55" />
        <stop offset={0.5} stopColor="#FF543E" />
        <stop offset={1} stopColor="#C837AB" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_12149_26465"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-5.36012 2.30512) rotate(78.681) scale(14.1765 58.436)"
      >
        <stop stopColor="#3771C8" />
        <stop offset={0.128} stopColor="#3771C8" />
        <stop offset={1} stopColor="#6600FF" stopOpacity={0} />
      </radialGradient>
      <clipPath id="clip0_12149_26465">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkedinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12149_26473)">
      <path
        d="M16.8438 0H5.15625C2.30853 0 0 2.30853 0 5.15625V16.8438C0 19.6915 2.30853 22 5.15625 22H16.8438C19.6915 22 22 19.6915 22 16.8438V5.15625C22 2.30853 19.6915 0 16.8438 0Z"
        fill="white"
      />
      <path
        d="M16.8438 0H5.15625C2.30853 0 0 2.30853 0 5.15625V16.8438C0 19.6915 2.30853 22 5.15625 22H16.8438C19.6915 22 22 19.6915 22 16.8438V5.15625C22 2.30853 19.6915 0 16.8438 0Z"
        fill="#0A66C2"
      />
      <path
        d="M15.8739 18.7073H18.3893C18.4805 18.7073 18.5679 18.6711 18.6324 18.6067C18.6968 18.5422 18.7331 18.4548 18.7331 18.3636L18.7344 13.0491C18.7344 10.2713 18.1358 8.13622 14.8897 8.13622C13.6557 8.09033 12.492 8.72644 11.8641 9.78862C11.861 9.79378 11.8564 9.7978 11.8508 9.80005C11.8452 9.80231 11.8391 9.80268 11.8333 9.80111C11.8275 9.79954 11.8224 9.79612 11.8187 9.79137C11.815 9.78661 11.813 9.78079 11.813 9.77479V8.73641C11.813 8.64524 11.7768 8.5578 11.7123 8.49334C11.6478 8.42887 11.5604 8.39266 11.4692 8.39266H9.08213C8.99096 8.39266 8.90353 8.42887 8.83907 8.49334C8.7746 8.5578 8.73838 8.64524 8.73838 8.73641V18.3631C8.73838 18.4543 8.7746 18.5417 8.83907 18.6062C8.90353 18.6707 8.99096 18.7069 9.08213 18.7069H11.5974C11.6885 18.7069 11.776 18.6707 11.8404 18.6062C11.9049 18.5417 11.9411 18.4543 11.9411 18.3631V13.6045C11.9411 12.259 12.1963 10.9559 13.8645 10.9559C15.5089 10.9559 15.5302 12.4956 15.5302 13.6916V18.3636C15.5302 18.4547 15.5664 18.5422 15.6309 18.6066C15.6953 18.6711 15.7828 18.7073 15.8739 18.7073ZM3.26562 5.12428C3.26562 6.14384 4.10498 6.98277 5.12462 6.98277C6.14402 6.98268 6.98285 6.14324 6.98285 5.12385C6.98268 4.10446 6.14376 3.26562 5.12428 3.26562C4.10455 3.26562 3.26562 4.10472 3.26562 5.12428ZM3.86366 18.7073H6.38223C6.4734 18.7073 6.56084 18.6711 6.6253 18.6066C6.68977 18.5422 6.72598 18.4547 6.72598 18.3636V8.73641C6.72598 8.64524 6.68977 8.5578 6.6253 8.49334C6.56084 8.42887 6.4734 8.39266 6.38223 8.39266H3.86366C3.7725 8.39266 3.68506 8.42887 3.6206 8.49334C3.55613 8.5578 3.51991 8.64524 3.51991 8.73641V18.3636C3.51991 18.4547 3.55613 18.5422 3.6206 18.6066C3.68506 18.6711 3.7725 18.7073 3.86366 18.7073Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12149_26473">
        <rect width={22} height={22} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DownloadSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={39} height={39} rx={3.5} stroke="#B4CEF5" />
    <path
      d="M19.9993 24.1702C19.8438 24.1702 19.698 24.1461 19.5618 24.0979C19.4257 24.0496 19.2993 23.9668 19.1827 23.8494L14.9827 19.6494C14.7493 19.416 14.6373 19.1438 14.6467 18.8327C14.656 18.5216 14.768 18.2494 14.9827 18.016C15.216 17.7827 15.4933 17.6614 15.8145 17.652C16.1357 17.6427 16.4126 17.7543 16.6452 17.9869L18.8327 20.1744V11.8327C18.8327 11.5021 18.9447 11.2252 19.1687 11.002C19.3927 10.7788 19.6696 10.6668 19.9993 10.666C20.3291 10.6652 20.6064 10.7772 20.8312 11.002C21.056 11.2268 21.1676 11.5037 21.166 11.8327V20.1744L23.3535 17.9869C23.5869 17.7535 23.8641 17.6415 24.1854 17.6509C24.5066 17.6602 24.7835 17.7819 25.016 18.016C25.2299 18.2494 25.3419 18.5216 25.352 18.8327C25.3621 19.1438 25.2501 19.416 25.016 19.6494L20.816 23.8494C20.6993 23.966 20.573 24.0489 20.4368 24.0979C20.3007 24.1469 20.1549 24.171 19.9993 24.1702ZM12.9993 29.3327C12.3577 29.3327 11.8086 29.1044 11.352 28.6479C10.8955 28.1913 10.6668 27.6418 10.666 26.9994V24.666C10.666 24.3355 10.778 24.0586 11.002 23.8354C11.226 23.6121 11.5029 23.5001 11.8327 23.4994C12.1625 23.4986 12.4397 23.6106 12.6645 23.8354C12.8893 24.0601 13.0009 24.337 12.9993 24.666V26.9994H26.9993V24.666C26.9993 24.3355 27.1114 24.0586 27.3354 23.8354C27.5594 23.6121 27.8362 23.5001 28.166 23.4994C28.4958 23.4986 28.7731 23.6106 28.9978 23.8354C29.2226 24.0601 29.3342 24.337 29.3327 24.666V26.9994C29.3327 27.641 29.1044 28.1905 28.6479 28.6479C28.1913 29.1052 27.6418 29.3335 26.9993 29.3327H12.9993Z"
      fill="#7387A7"
    />
  </svg>
);

export const PrintSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={39} height={39} rx={3.5} stroke="#B4CEF5" />
    <path
      d="M24 16V13H16V16H14V11H26V16H24ZM26 20.5C26.2833 20.5 26.521 20.404 26.713 20.212C26.905 20.02 27.0007 19.7827 27 19.5C26.9993 19.2173 26.9033 18.98 26.712 18.788C26.5207 18.596 26.2833 18.5 26 18.5C25.7167 18.5 25.4793 18.596 25.288 18.788C25.0967 18.98 25.0007 19.2173 25 19.5C24.9993 19.7827 25.0953 20.0203 25.288 20.213C25.4807 20.4057 25.718 20.5013 26 20.5ZM24 27V23H16V27H24ZM26 29H14V25H10V19C10 18.15 10.2917 17.4377 10.875 16.863C11.4583 16.2883 12.1667 16.0007 13 16H27C27.85 16 28.5627 16.2877 29.138 16.863C29.7133 17.4383 30.0007 18.1507 30 19V25H26V29ZM28 23V19C28 18.7167 27.904 18.4793 27.712 18.288C27.52 18.0967 27.2827 18.0007 27 18H13C12.7167 18 12.4793 18.096 12.288 18.288C12.0967 18.48 12.0007 18.7173 12 19V23H14V21H26V23H28Z"
      fill="#7387A7"
    />
  </svg>
);

export const ShareSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={39} height={39} rx={3.5} stroke="#B4CEF5" />
    <path
      d="M25 30C24.1667 30 23.4583 29.7083 22.875 29.125C22.2917 28.5417 22 27.8333 22 27C22 26.9 22.025 26.6667 22.075 26.3L15.05 22.2C14.7833 22.45 14.475 22.646 14.125 22.788C13.775 22.93 13.4 23.0007 13 23C12.1667 23 11.4583 22.7083 10.875 22.125C10.2917 21.5417 10 20.8333 10 20C10 19.1667 10.2917 18.4583 10.875 17.875C11.4583 17.2917 12.1667 17 13 17C13.4 17 13.775 17.071 14.125 17.213C14.475 17.355 14.7833 17.5507 15.05 17.8L22.075 13.7C22.0417 13.5833 22.021 13.471 22.013 13.363C22.005 13.255 22.0007 13.134 22 13C22 12.1667 22.2917 11.4583 22.875 10.875C23.4583 10.2917 24.1667 10 25 10C25.8333 10 26.5417 10.2917 27.125 10.875C27.7083 11.4583 28 12.1667 28 13C28 13.8333 27.7083 14.5417 27.125 15.125C26.5417 15.7083 25.8333 16 25 16C24.6 16 24.225 15.929 23.875 15.787C23.525 15.645 23.2167 15.4493 22.95 15.2L15.925 19.3C15.9583 19.4167 15.9793 19.5293 15.988 19.638C15.9967 19.7467 16.0007 19.8673 16 20C15.9993 20.1327 15.9953 20.2537 15.988 20.363C15.9807 20.4723 15.9597 20.5847 15.925 20.7L22.95 24.8C23.2167 24.55 23.525 24.3543 23.875 24.213C24.225 24.0717 24.6 24.0007 25 24C25.8333 24 26.5417 24.2917 27.125 24.875C27.7083 25.4583 28 26.1667 28 27C28 27.8333 27.7083 28.5417 27.125 29.125C26.5417 29.7083 25.8333 30 25 30ZM25 28C25.2833 28 25.521 27.9043 25.713 27.713C25.905 27.5217 26.0007 27.284 26 27C25.9993 26.716 25.9033 26.4787 25.712 26.288C25.5207 26.0973 25.2833 26.0013 25 26C24.7167 25.9987 24.4793 26.0947 24.288 26.288C24.0967 26.4813 24.0007 26.7187 24 27C23.9993 27.2813 24.0953 27.519 24.288 27.713C24.4807 27.907 24.718 28.0027 25 28ZM13 21C13.2833 21 13.521 20.904 13.713 20.712C13.905 20.52 14.0007 20.2827 14 20C13.9993 19.7173 13.9033 19.48 13.712 19.288C13.5207 19.096 13.2833 19 13 19C12.7167 19 12.4793 19.096 12.288 19.288C12.0967 19.48 12.0007 19.7173 12 20C11.9993 20.2827 12.0953 20.5203 12.288 20.713C12.4807 20.9057 12.718 21.0013 13 21ZM25 14C25.2833 14 25.521 13.904 25.713 13.712C25.905 13.52 26.0007 13.2827 26 13C25.9993 12.7173 25.9033 12.48 25.712 12.288C25.5207 12.096 25.2833 12 25 12C24.7167 12 24.4793 12.096 24.288 12.288C24.0967 12.48 24.0007 12.7173 24 13C23.9993 13.2827 24.0953 13.5203 24.288 13.713C24.4807 13.9057 24.718 14.0013 25 14Z"
      fill="#7387A7"
    />
  </svg>
);

export const LinkOpenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 17.5V2.5H8.40833V4.16667H4.16667V15.8333H15.8333V11.5917H17.5V17.5H2.5ZM8.82167 10L14.655 4.16667H10.8333V2.5H17.5V9.16667H15.8333V5.345L10 11.1783L8.82167 10Z"
      fill="#1E49E2"
    />
  </svg>
);

export const UploadIcon1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={57}
    height={56}
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.5 42.308V7.708L17.18 17.028L14.348 14.156L28.5 0L42.656 14.156L39.824 17.032L30.5 7.708V42.308H26.5ZM6.964 56C5.12133 56 3.584 55.384 2.352 54.152C1.12 52.92 0.502667 51.3813 0.5 49.536V39.844H4.5V49.536C4.5 50.152 4.756 50.7173 5.268 51.232C5.78 51.7467 6.344 52.0027 6.96 52H50.04C50.6533 52 51.2173 51.744 51.732 51.232C52.2467 50.72 52.5027 50.1547 52.5 49.536V39.844H56.5V49.536C56.5 51.3787 55.884 52.916 54.652 54.148C53.42 55.38 51.8813 55.9973 50.036 56H6.964Z"
      fill="#D4DEEF"
    />
  </svg>
);

export const CertifyArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 29 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_12059_30743)">
      <path
        d="M25.525 5.03516L13.3733 17.1032C11.6954 18.7693 8.97524 18.7693 7.29743 17.1032L3.5 13.3319"
        stroke="white"
        strokeWidth="5.1087"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1094 3.75H27.2146V9.75"
        stroke="white"
        strokeWidth="4.08696"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12059_30743">
        <rect width="29" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BGColorFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6251 12.3744C16.1251 13.9419 16.8751 15.1138 16.8751 15.89C16.8751 17.0555 15.8682 17.9994 14.6251 17.9994C13.3819 17.9994 12.3751 17.0544 12.3751 15.89C12.3751 15.1138 13.1251 13.9419 14.6251 12.3744ZM6.58919 0.168165L13.7217 7.42441L13.7397 7.44691L14.1042 7.80804C14.4003 8.10228 14.5768 8.49583 14.5997 8.91264C14.6225 9.32945 14.4901 9.73994 14.2279 10.0648L14.1121 10.193L9.07881 15.2702C8.92267 15.4277 8.73699 15.553 8.5324 15.6387C8.32781 15.7245 8.10832 15.769 7.88649 15.7699C7.66466 15.7707 7.44484 15.7278 7.23961 15.6436C7.03438 15.5594 6.84776 15.4356 6.69044 15.2792L1.64706 10.1919C1.33209 9.87447 1.156 9.44497 1.15748 8.99779C1.15896 8.5506 1.33788 8.12228 1.65494 7.80691L6.68594 2.80066C6.84906 2.63641 7.03806 2.51491 7.23944 2.43279L5.78706 0.955665C5.68957 0.847991 5.63751 0.706779 5.64178 0.561591C5.64605 0.416402 5.70632 0.278494 5.80997 0.176735C5.91362 0.0749762 6.05261 0.0172565 6.19785 0.0156591C6.34309 0.0140616 6.48332 0.0687102 6.58919 0.168165ZM8.27219 3.59829C8.16679 3.49352 8.02423 3.43472 7.87562 3.43472C7.72702 3.43472 7.58445 3.49352 7.47906 3.59829L2.44919 8.60567C2.34403 8.70989 2.2842 8.85137 2.28269 8.99941H13.4764C13.4749 8.85137 13.4151 8.70989 13.3099 8.60567L8.27219 3.59941V3.59829Z"
      fill="black"
    />
  </svg>
);

export const LandingTimer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 16.0007H17.3333V13.334C17.3333 12.5967 16.736 12.0007 16 12.0007C15.264 12.0007 14.6667 12.5967 14.6667 13.334V17.334C14.6667 18.0713 15.264 18.6673 16 18.6673H20C20.736 18.6673 21.3333 18.0713 21.3333 17.334C21.3333 16.5967 20.736 16.0007 20 16.0007ZM16 26.334C11.0373 26.334 7 22.2966 7 17.334C7 12.3713 11.0373 8.33398 16 8.33398C20.9627 8.33398 25 12.3713 25 17.334C25 22.2966 20.9627 26.334 16 26.334ZM17.3173 5.41132C17.32 5.38332 17.3333 5.36198 17.3333 5.33398V4.00065H18.6667C19.4027 4.00065 20 3.40465 20 2.66732C20 1.92998 19.4027 1.33398 18.6667 1.33398H13.3333C12.5973 1.33398 12 1.92998 12 2.66732C12 3.40465 12.5973 4.00065 13.3333 4.00065H14.6667V5.33398C14.6667 5.36198 14.68 5.38332 14.6827 5.41132C8.684 6.06998 4 11.1633 4 17.334C4 23.9513 9.384 29.334 16 29.334C22.616 29.334 28 23.9513 28 17.334C28 11.1633 23.316 6.06998 17.3173 5.41132Z"
      fill="#03133D"
    />
    <mask
      id="mask0_12034_27361"
      // style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="4"
      y="1"
      width="24"
      height="29"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 16.0007H17.3333V13.334C17.3333 12.5967 16.736 12.0007 16 12.0007C15.264 12.0007 14.6667 12.5967 14.6667 13.334V17.334C14.6667 18.0713 15.264 18.6673 16 18.6673H20C20.736 18.6673 21.3333 18.0713 21.3333 17.334C21.3333 16.5967 20.736 16.0007 20 16.0007ZM16 26.334C11.0373 26.334 7 22.2966 7 17.334C7 12.3713 11.0373 8.33398 16 8.33398C20.9627 8.33398 25 12.3713 25 17.334C25 22.2966 20.9627 26.334 16 26.334ZM17.3173 5.41132C17.32 5.38332 17.3333 5.36198 17.3333 5.33398V4.00065H18.6667C19.4027 4.00065 20 3.40465 20 2.66732C20 1.92998 19.4027 1.33398 18.6667 1.33398H13.3333C12.5973 1.33398 12 1.92998 12 2.66732C12 3.40465 12.5973 4.00065 13.3333 4.00065H14.6667V5.33398C14.6667 5.36198 14.68 5.38332 14.6827 5.41132C8.684 6.06998 4 11.1633 4 17.334C4 23.9513 9.384 29.334 16 29.334C22.616 29.334 28 23.9513 28 17.334C28 11.1633 23.316 6.06998 17.3173 5.41132Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_12034_27361)">
      <rect width="32" height="32" fill="white" />
    </g>
  </svg>
);

export const LandingLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.0007 21.3327C15.2647 21.3327 14.6673 20.7353 14.6673 19.9993C14.6673 19.2633 15.2647 18.666 16.0007 18.666C16.7367 18.666 17.334 19.2633 17.334 19.9993C17.334 20.7353 16.7367 21.3327 16.0007 21.3327ZM16.0007 15.9993C13.7953 15.9993 12.0007 17.794 12.0007 19.9993C12.0007 22.2047 13.7953 23.9993 16.0007 23.9993C18.206 23.9993 20.0007 22.2047 20.0007 19.9993C20.0007 17.794 18.206 15.9993 16.0007 15.9993ZM24.0007 25.3327C24.0007 26.0687 23.4033 26.666 22.6673 26.666H9.33398C8.59798 26.666 8.00065 26.0687 8.00065 25.3327V14.666C8.00065 13.93 8.59798 13.3327 9.33398 13.3327H10.6673H13.334H18.6673H21.334H22.6673C23.4033 13.3327 24.0007 13.93 24.0007 14.666V25.3327ZM13.334 8.14735C13.334 6.59535 14.53 5.33268 16.0007 5.33268C17.4713 5.33268 18.6673 6.59535 18.6673 8.14735V10.666H13.334V8.14735ZM22.6673 10.666H21.334V8.14735C21.334 5.12602 18.942 2.66602 16.0007 2.66602C13.0593 2.66602 10.6673 5.12602 10.6673 8.14735V10.666H9.33398C7.12865 10.666 5.33398 12.4607 5.33398 14.666V25.3327C5.33398 27.538 7.12865 29.3327 9.33398 29.3327H22.6673C24.8727 29.3327 26.6673 27.538 26.6673 25.3327V14.666C26.6673 12.4607 24.8727 10.666 22.6673 10.666Z"
      fill="#03133D"
    />
    <mask
      id="mask0_12034_27434"
      // style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="5"
      y="2"
      width="22"
      height="28"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0007 21.3327C15.2647 21.3327 14.6673 20.7353 14.6673 19.9993C14.6673 19.2633 15.2647 18.666 16.0007 18.666C16.7367 18.666 17.334 19.2633 17.334 19.9993C17.334 20.7353 16.7367 21.3327 16.0007 21.3327ZM16.0007 15.9993C13.7953 15.9993 12.0007 17.794 12.0007 19.9993C12.0007 22.2047 13.7953 23.9993 16.0007 23.9993C18.206 23.9993 20.0007 22.2047 20.0007 19.9993C20.0007 17.794 18.206 15.9993 16.0007 15.9993ZM24.0007 25.3327C24.0007 26.0687 23.4033 26.666 22.6673 26.666H9.33398C8.59798 26.666 8.00065 26.0687 8.00065 25.3327V14.666C8.00065 13.93 8.59798 13.3327 9.33398 13.3327H10.6673H13.334H18.6673H21.334H22.6673C23.4033 13.3327 24.0007 13.93 24.0007 14.666V25.3327ZM13.334 8.14735C13.334 6.59535 14.53 5.33268 16.0007 5.33268C17.4713 5.33268 18.6673 6.59535 18.6673 8.14735V10.666H13.334V8.14735ZM22.6673 10.666H21.334V8.14735C21.334 5.12602 18.942 2.66602 16.0007 2.66602C13.0593 2.66602 10.6673 5.12602 10.6673 8.14735V10.666H9.33398C7.12865 10.666 5.33398 12.4607 5.33398 14.666V25.3327C5.33398 27.538 7.12865 29.3327 9.33398 29.3327H22.6673C24.8727 29.3327 26.6673 27.538 26.6673 25.3327V14.666C26.6673 12.4607 24.8727 10.666 22.6673 10.666Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_12034_27434)">
      <rect width="32" height="32" fill="white" />
    </g>
  </svg>
);

export const LandingPc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.666 18.6667C26.666 19.4013 26.0687 20 25.3327 20H16.1153H15.8833H6.66602C5.93002 20 5.33268 19.4013 5.33268 18.6667V8C5.33268 7.26533 5.93002 6.66667 6.66602 6.66667H25.3327C26.0687 6.66667 26.666 7.26533 26.666 8V18.6667ZM25.3327 4H6.66602C4.46068 4 2.66602 5.79467 2.66602 8V18.6667C2.66602 20.872 4.46068 22.6667 6.66602 22.6667H14.666V25.3333H9.33268C8.59935 25.3333 7.99935 25.9333 7.99935 26.6667C7.99935 27.4 8.59935 28 9.33268 28H22.666C23.3993 28 23.9993 27.4 23.9993 26.6667C23.9993 25.9333 23.3993 25.3333 22.666 25.3333H17.3327V22.6667H25.3327C27.538 22.6667 29.3327 20.872 29.3327 18.6667V8C29.3327 5.79467 27.538 4 25.3327 4Z"
      fill="#03133D"
    />
    <mask
      id="mask0_12034_27444"
      // style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="2"
      y="4"
      width="28"
      height="24"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.666 18.6667C26.666 19.4013 26.0687 20 25.3327 20H16.1153H15.8833H6.66602C5.93002 20 5.33268 19.4013 5.33268 18.6667V8C5.33268 7.26533 5.93002 6.66667 6.66602 6.66667H25.3327C26.0687 6.66667 26.666 7.26533 26.666 8V18.6667ZM25.3327 4H6.66602C4.46068 4 2.66602 5.79467 2.66602 8V18.6667C2.66602 20.872 4.46068 22.6667 6.66602 22.6667H14.666V25.3333H9.33268C8.59935 25.3333 7.99935 25.9333 7.99935 26.6667C7.99935 27.4 8.59935 28 9.33268 28H22.666C23.3993 28 23.9993 27.4 23.9993 26.6667C23.9993 25.9333 23.3993 25.3333 22.666 25.3333H17.3327V22.6667H25.3327C27.538 22.6667 29.3327 20.872 29.3327 18.6667V8C29.3327 5.79467 27.538 4 25.3327 4Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_12034_27444)">
      <rect width="32" height="32" fill="white" />
    </g>
  </svg>
);

export const UploadFileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1668 17.9617V3.54504L7.2835 7.42837L6.1035 6.23171L12.0002 0.333374L17.8985 6.23171L16.7185 7.43004L12.8335 3.54504V17.9617H11.1668ZM0.333496 23.6667V16.9367H2.00016V22H22.0002V16.9367H23.6668V23.6667H0.333496Z"
      fill="#00338D"
    />
  </svg>
);

export const DownloadIcon1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.71875 7.64746L10 10.9287L13.2812 7.64746"
      stroke="#1E49E2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 2.17871V10.9287"
      stroke="#1E49E2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.875 10.9287V15.3037C16.875 15.4695 16.8092 15.6284 16.6919 15.7457C16.5747 15.8629 16.4158 15.9287 16.25 15.9287H3.75C3.58424 15.9287 3.42527 15.8629 3.30806 15.7457C3.19085 15.6284 3.125 15.4695 3.125 15.3037V10.9287"
      stroke="#1E49E2"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ExcelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
);
